import React, { useState, useEffect, useRef } from 'react'
import {
    DialogTitle,
    Grid, Button, IconButton, DialogContent, DialogActions, Dialog, Divider, Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, Paper,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import DeferredTextField from './controls/DeferredTextField';
import { isEmpty } from 'lodash';
import Controls from "./controls/Controls";
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import _ from 'lodash';
import dayjs from 'dayjs';
import { useAuthStore } from '../store/authStore';
import { fetchData, fetchDataPromise } from '../services/ApiServices';
import {
    urlAccountants, urlLegalForms, urlClientTariff,
    urlClientPackage, urlReasonForTerminatingCooperation,
    urlContactRoles, urlUsers, urlFizen
} from '../config';
import TimelineComponent from './TimelineComponent';
import DiscountComponent from './DiscountComponent'
import CloseIcon from '@mui/icons-material/Close';
import { urlClientsFakturownia, urlLivespace } from '../config';
import * as CommonFunctions from "../services/CommonFunctions";
import * as MyCollections from "../services/MyCollections";

export default function FormDialog({ open, handleClose, handleFormSubmit, setFormData, formData }) {
const { id, companyName, companyWorkingName, addressEntity, nip, krs, clientContactDTOs, legalFormId, isCompanyEstablishedBy7PM, vatStatus,
        isOptima, isInsert, isContract, isContinuationOfJDG, isTransferOfAccounting, isFakturownia, fakturowniaPayableFrom, isGenerateInvoice, dateOfEntryInKRS, firstFiscalYear,
        tradersComments, businessDesc, clientTariffDTOs, clientPackageDTOs, cooperationHistoryDTOs, accountantDTOs, emails, additionalContact, uplSupervisor, isPaidInAdvance,
        paidInAdvanceTo, fakturowniaPrice, currentSupervisorName, obtainedByContactId, cooperationStatus, accountManagerId, clientPanelUrl, isActive } = formData
    const { roles: roles } = useAuthStore();

    const contactId = useAuthStore().contactId;
    const userName = useAuthStore().fullName;
    const [errors, setErrors] = useState({});
    const [cooperationEndedClicked, setCooperationEndedClicked] = useState(false);
    const [cooperationSuspendedClicked, setCooperationSuspendedClicked] = useState(false);
    const [isResume, setIsResume] = useState(false);
    const [cooperationEnded, setCooperationEnded] = useState(false);
    const [openEndDialog, setOpenEndDialog] = useState(false);
    const [openSuspendDialog, setOpenSuspendDialog] = useState(false);
    const [openResumeDialog, setOpenResumeDialog] = useState(false);
    const [localEndDate, setLocalEndDate] = useState('');
    const [localStartDate, setLocalStartDate] = useState('');
    const [localResumeDate, setLocalResumeDate] = useState('');
    const [localReasonId, setLocalReasonId] = useState('');
    const [localErrors, setLocalErrors] = useState({});
    const token = useAuthStore().token;
    const [cooperationHistoryList, setCooperationHistoryList] = useState([]);
    const [changeAllowed, setChangeAllowed] = useState(true);
    const isAccountantSet = useRef(false);
    const [minDate, setMinDate] = useState('2020-01-01');
    const [tariffs, setTariffs] = useState([]);
    const [packages, setPackages] = useState([]);
    const [packagesLocal, setPackagesLocal] = useState(packages);
    const [reasons, setReasons] = useState([]);
    const [activeAccountants, setActiveAccountants] = useState([]);
    const [accountants, setAccountants] = useState([]);
    const [legalForms, setlegalForms] = useState([]);
    const [users, setUsers] = useState([]);
    const [accountManagers, setAccountManagers] = useState([]);
    const [contactRoles, setContactRoles] = useState([]);
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
    const phoneNumberRegex = /^[0-9+:\s]{9,20}$/;
    const postalCodeRegex = /^\d{2}-\d{3}$/;
    const nipRegex = /^[0-9]{10}$/;
    const krsRegex = /^[0-9]{10}$/;
    const numberRegex = /^\d+$/;
    const Div = styled('div')(({ theme }) => ({
        ...theme.typography.button,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(1),
        fontSize: 15
    }));
    const isViewOnly = roles?.includes('ACCOUNTANT') || roles?.includes('CHIEF_ACCOUNTANT');
    const isRemoveButtonVisible = roles?.includes('ADMIN') || roles?.includes('ADMIN_SUPERVISOR') || roles?.includes('MANAGER');
    const [accounts, setAccounts] = useState([]);
    const [selectedFormat, setSelectedFormat] = useState("mt940");

    // Derived values - computed from props to avoid per-keystroke re-renders
    const active = isActive;
    const gmail = emails?.find(email => email.temailTypeId === 11)?.emailAddress || '';
    const invoiceEmail = emails?.find(email => email.temailTypeId === 31)?.emailAddress || '';
    const cooperationEndedInFuture = cooperationStatus === "FUTURE_END";
    const suspensionStartDateInFuture = cooperationStatus === "FUTURE_SUSPENSION";
    const suspensionEndDateInFuture = cooperationStatus === "FUTURE_UNDO_SUSPENSION";
    const cooperationStartsInFuture = cooperationStatus === "FUTURE_START";
    const suspended = cooperationStatus === "SUSPENDED";
    const isResumingFromSuspension = isResume && cooperationHistoryDTOs?.[1]?.suspended;
    const hasResumedFromEnded = cooperationHistoryDTOs?.length > 1 && cooperationHistoryDTOs[0]?.cooperationStartDate !== cooperationHistoryDTOs[cooperationHistoryDTOs.length - 1]?.cooperationStartDate;
    const clientContacts = clientContactDTOs?.length > 0 ? clientContactDTOs : [];
    const tariffList = clientTariffDTOs?.length > 0 ? clientTariffDTOs : [{}];
    const packageList = clientPackageDTOs?.length > 0 ? clientPackageDTOs : [{}];
    const accountantList = accountantDTOs?.length > 0 ? accountantDTOs : [];
    const currentAccountant = accountantDTOs?.length > 0
        ? `${accountantDTOs[0].surname || ''} ${accountantDTOs[0].name || ''}`.trim()
        : '';
    let disabledButton = active || cooperationStartsInFuture;

    const mapToSelect = (item) => ({
        key: item.id,
        value: item.surname + ' ' + item.name,
        maxNumberOfClients: item.maxNumberOfClients,
        activeClients: item.activeClients
    });

    const mapToSelect3 = (item) => ({
        key: item.contactId,
        value: item.lastName + " " + item.firstName,
    });

    useEffect(() => {
        setAccounts([]);
        if (!open) return;

        const loadData = async () => {
            try {
                const deepCopy = cooperationHistoryDTOs?.length > 0
                    ? JSON.parse(JSON.stringify(cooperationHistoryDTOs))
                    : [{}];
                setCooperationHistoryList(deepCopy);
                setCooperationEndedClicked(false);
                setCooperationSuspendedClicked(false);
                // suspended and cooperationStartsInFuture are now derived from cooperationStatus
                setCooperationEnded(cooperationStatus === "ENDED");
                setIsResume(false);
                setIsSubmitting(false);
                await Promise.all([
                    fetchDataPromise(urlAccountants + '/allActiveForSelect', mapToSelect, setActiveAccountants, console.error, token),
                    fetchDataPromise(urlAccountants + '/allForSelect', mapToSelect, setAccountants, console.error, token),
                    fetchDataPromise(urlLegalForms + '/allForSelect', mapToSelect2, setlegalForms, console.error, token),
                    fetchDataPromise(urlContactRoles + '/allForSelect', mapToSelect2, setContactRoles, console.error, token),
                    fetchDataPromise(urlUsers + '/allForSelectFiltered', mapToSelect3, setUsers, console.error, token),
                    fetchDataPromise(urlUsers + '/allAccountManagers', mapToSelect3, (data) => setAccountManagers([{ key: null, value: 'Brak' }, ...data]), console.error, token),
                    fetchDataPromise(urlClientTariff + '/allForSelect', mapToSelect2, (data) => {
                        const assignedIds = clientTariffDTOs?.map(ct => ct.tclientTariffId) || [];
                        setTariffs(data.filter(t => !t.discontinueDate || assignedIds.includes(t.key)));
                    }, console.error, token),
                    fetchDataPromise(urlReasonForTerminatingCooperation + '/allForSelect', mapToSelect2, setReasons, console.error, token),
                    fetchDataPromise(urlClientPackage + '/allForSelect', mapToSelect2, setPackages, console.error, token),
                ]);
            } catch (err) {
                console.error('Błąd przy ładowaniu danych:', err);
                // Możesz dodatkowo ustawić ogólny błąd np. setGlobalError(err);
            }
        };

        void loadData(); // bez await, żeby nie ostrzegał React o zwróconej obietnicy
    }, [open]);

    useEffect(() => {
        if (clientTariffDTOs?.length > 0 && clientTariffDTOs[0].tclientTariffId) {
            fetchData(urlClientPackage + `/?tariffId=${clientTariffDTOs[0].tclientTariffId}&isForClient=true`, mapToSelect2, setPackagesLocal, console.error, token);
        }
    }, [clientTariffDTOs[0].tclientTariffId]);

    const ConditionButton = styled(Button)(({ theme }) => ({
        marginTop: 15,
    }));
    const EndButton = styled(Button)(({ theme }) => ({
        marginTop: 28,
        width: "100%"
    }));

    const mapToSelect2 = (item) => {
        return {
            key: item.id,
            value: item.description,
            discontinueDate: item.discontinueDate
        };
    };

    const validateFormOnSubmit = () => {
        let formIsValid = true;
        let errors = {};

        if (active === true) {
            if (isEmpty(companyName)) {
                errors.companyName = 'Pole jest wymagane';
                formIsValid = false;
            }
            if (isEmpty(companyWorkingName)) {
                errors.companyWorkingName = 'Pole jest wymagane';
                formIsValid = false;
            }
            if (nip.length === 0) {
                errors.nip = 'Pole jest wymagane';
                formIsValid = false;
            }
            if (!nipRegex.test(nip)) {
                errors.nip = 'Wprowadź poprawny numer NIP';
                formIsValid = false;
            }
            if (legalFormId !== 1 && (!krs || krs.length === 0)) {
                errors.krs = 'Pole jest wymagane';
                formIsValid = false;
            }
            else if (legalFormId !== 1 && !krsRegex.test(krs)) {
                errors.krs = 'Wprowadź poprawny numer KRS';
                formIsValid = false;
            }
            if (isEmpty(invoiceEmail)) {
                errors.invoiceEmail = 'Pole jest wymagane';
                formIsValid = false;
            }
            if (isContract === '' || isContract === null || isContract === 0) {
                errors.isContract = 'Pole jest wymagane';
                formIsValid = false;
            }
            if (isGenerateInvoice === '' || isGenerateInvoice === null || isGenerateInvoice === 0) {
                errors.isGenerateInvoice = 'Pole jest wymagane';
                formIsValid = false;
            }
            if (legalFormId === '' || legalFormId === null || legalFormId === 0) {
                errors.legalFormId = 'Pole jest wymagane';
                formIsValid = false;
            }

            if (dateOfEntryInKRS === '' || dateOfEntryInKRS === null) {
                errors.dateOfEntryInKRS = 'Pole jest wymagane';
                formIsValid = false;
            }
            if (legalFormId !== 1 && (firstFiscalYear === '' || firstFiscalYear === null)) {
                errors.firstFiscalYear = 'Pole jest wymagane';
                formIsValid = false;
            }
            // Inicjalizuj strukturę errors.clientContactDTOs, jeśli jeszcze nie istnieje
            if (!errors.clientContactDTOs) {
                errors.clientContactDTOs = [];
            }

            // Iteruj przez wszystkie elementy clientContactDTOs
            clientContactDTOs.forEach((contact, index) => {
                if (!errors.clientContactDTOs[index]) {
                    errors.clientContactDTOs[index] = { emails: [{}], phones: [{}] };
                }
                if (contact.name === '' || contact.name === null) {
                    errors.clientContactDTOs[index].name = 'Pole jest wymagane';
                    formIsValid = false;
                }
            });

            //Walidacja accountantDTOs
            if (!errors.accountantDTOs) {
                errors.accountantDTOs = [{}];
            }

            if (accountantDTOs.length > 0 && (accountantDTOs?.[0]?.startDate === '' || accountantDTOs?.[0]?.startDate === null || accountantDTOs?.[0]?.startDate === undefined)) {
                errors.accountantDTOs[0].startDate = 'Pole jest wymagane';
                formIsValid = false;
            }
            else if (accountantDTOs?.[0]?.startDate) {
                const startDate = new Date(accountantDTOs[0].startDate);
                const endDateOfPreviousElement = accountantDTOs[1] ? new Date(accountantDTOs[1].endDate) : null;
                if (endDateOfPreviousElement && (startDate <= endDateOfPreviousElement)) {
                    errors.accountantDTOs[0].startDate = 'Data początkowa musi być późniejsza niż data końcowa poprzedniego wiersza.';
                    formIsValid = false;
                }
            }

            if (accountantDTOs?.[0]?.contactIdA === '' || accountantDTOs?.[0]?.contactIdA === null) {
                errors.accountantDTOs[0].contactIdA = 'Pole jest wymagane';
                formIsValid = false;
            }

            if (accountantDTOs?.[0]?.startDate && accountantDTOs?.[0]?.endDate) {
                const startDate = new Date(accountantDTOs[0].startDate);
                const endDate = new Date(accountantDTOs[0].endDate);

                if (endDate < startDate) {
                    errors.accountantDTOs[0].endDate = 'Data końcowa nie może być wcześniejsza niż data początkowa';
                    formIsValid = false;
                }
            }
            // Walidacja clientTariffDTOs
            if (!errors.clientTariffDTOs) {
                errors.clientTariffDTOs = [{}];
            }

            if (clientTariffDTOs[0].tclientTariffId === '' || clientTariffDTOs[0].tclientTariffId === null) {
                errors.clientTariffDTOs[0].tclientTariffId = 'Pole jest wymagane';
                formIsValid = false;
            }

            if (clientTariffDTOs?.[0]?.tclientTariffId !== null && clientTariffDTOs?.[0]?.tclientTariffId !== '') {
                if (clientTariffDTOs[0].startDate === '' || clientTariffDTOs[0].startDate === null) {
                    errors.clientTariffDTOs[0].startDate = 'Pole jest wymagane';
                    formIsValid = false;
                }
                else {
                    const startDate = new Date(clientTariffDTOs[0].startDate);
                    const endDateOfPreviousElement = clientTariffDTOs[1] ? new Date(clientTariffDTOs[1].endDate) : null;
                    if (endDateOfPreviousElement && (startDate <= endDateOfPreviousElement)) {
                        errors.clientTariffDTOs[0].startDate = 'Data początkowa musi być późniejsza niż data końcowa poprzedniego wiersza.';
                        formIsValid = false;
                    }
                }
                if (clientTariffDTOs[0].startDate && clientTariffDTOs[0].endDate) {
                    const startDate = new Date(clientTariffDTOs[0].startDate);
                    const endDate = new Date(clientTariffDTOs[0].endDate);

                    if (endDate < startDate) {
                        errors.clientTariffDTOs[0].endDate = 'Data końcowa nie może być wcześniejsza niż data początkowa';
                        formIsValid = false;
                    }
                }
            }

            // Walidacja Cooperation History

            if (!errors.cooperationHistoryDTOs) {
                errors.cooperationHistoryDTOs = [{}, {}];
            }

            // Walidacja dla cooperationStartDate
            if (cooperationHistoryDTOs && (cooperationHistoryDTOs[0].cooperationStartDate === null || cooperationHistoryDTOs[0].cooperationStartDate === '')) {
                errors.cooperationHistoryDTOs[0].cooperationStartDate = 'Pole jest wymagane';
                formIsValid = false;
            }
            else if (isResume && cooperationHistoryDTOs[0]?.cooperationStartDate) {
                const startDate = cooperationHistoryDTOs[0] ? dayjs(cooperationHistoryDTOs[0].cooperationStartDate) : null;
                let endDateOfPreviousRecord = null;
                if (cooperationHistoryDTOs?.[1]?.cooperationEndDate) {
                    endDateOfPreviousRecord = cooperationHistoryDTOs[1] ? dayjs(cooperationHistoryDTOs[1].cooperationEndDate) : null;
                }
                if (endDateOfPreviousRecord && (startDate.isBefore(endDateOfPreviousRecord) || startDate.isSame(endDateOfPreviousRecord))) {
                    errors.cooperationHistoryDTOs[0].cooperationStartDate = "Data nie może być wcześniejsza niż data zakończenia współpracy z poprzedniego okresu.";
                    formIsValid = false;
                } else {
                    _.unset(errors, 'cooperationHistoryDTOs[0].cooperationStartDate');
                }
            }
            // Walidacja dla suspensionEndDate po resume
            if (
                cooperationHistoryDTOs &&
                cooperationHistoryDTOs[1] &&
                cooperationHistoryDTOs[1].suspensionStartDate !== null &&
                (cooperationHistoryDTOs[1].suspensionEndDate === null || cooperationHistoryDTOs[1].suspensionEndDate === '')
            ) {
                errors.cooperationHistoryDTOs[1].suspensionEndDate = 'Pole jest wymagane';
                formIsValid = false;
            }
            else if (isResume && cooperationHistoryDTOs[1]?.suspensionEndDate) {
                const suspensionEndDate = cooperationHistoryDTOs[1] ? dayjs(cooperationHistoryDTOs[1].suspensionEndDate) : null;
                let startDateOfPreviousRecord = null;
                if (cooperationHistoryDTOs?.[1]?.suspensionStartDate) {
                    startDateOfPreviousRecord = cooperationHistoryDTOs[1] ? dayjs(cooperationHistoryDTOs[1].suspensionStartDate) : null;
                }
                if (startDateOfPreviousRecord && suspensionEndDate.isBefore(startDateOfPreviousRecord)) {
                    errors.cooperationHistoryDTOs[1].suspensionEndDate = "Data nie może być wcześniejsza niż data zawieszenia.";
                    formIsValid = false;
                } else {
                    _.unset(errors, 'cooperationHistoryDTOs[0].suspensionStartDate');
                }
            }

            // Walidacja clientPackage
            if (!errors.clientPackageDTOs) {
                errors.clientPackageDTOs = [{}];
            }

            if (clientPackageDTOs[0].tpackageTypeId === '' || clientPackageDTOs[0].tpackageTypeId === null) {
                errors.clientPackageDTOs[0].tpackageTypeId = 'Pole jest wymagane';
                formIsValid = false;
            }
            if (clientPackageDTOs?.[0]?.tpackageTypeId !== null && clientPackageDTOs?.[0]?.tpackageTypeId !== '') {
                if (clientPackageDTOs[0].startDate === '' || clientPackageDTOs[0].startDate === null) {
                    errors.clientPackageDTOs[0].startDate = 'Pole jest wymagane';
                    formIsValid = false;
                }
                else {
                    const startDate = new Date(clientPackageDTOs[0].startDate);
                    const endDateOfPreviousElement = clientPackageDTOs[1] ? new Date(clientPackageDTOs[1].endDate) : null;

                    if (endDateOfPreviousElement && (startDate <= endDateOfPreviousElement)) {
                        errors.clientPackageDTOs[0].startDate = 'Data początkowa musi być późniejsza niż data końcowa poprzedniego wiersza.';
                        formIsValid = false;
                    }
                }
                if (clientPackageDTOs[0].startDate && clientPackageDTOs[0].endDate) {
                    const startDate = new Date(clientPackageDTOs[0].startDate);
                    const endDate = new Date(clientPackageDTOs[0].endDate);

                    if (endDate < startDate) {
                        errors.clientPackageDTOs[0].endDate = 'Data końcowa nie może być wcześniejsza niż data początkowa';
                        formIsValid = false;
                    }
                }
            }

            // Walidacja Adresu
            if (!errors.addressEntity) {
                errors.addressEntity = {};
            }
            if (addressEntity === null || addressEntity.street === null || addressEntity.street === '') {
                errors.addressEntity.street = 'Pole jest wymagane';
                formIsValid = false;
            }

            if (addressEntity === null || addressEntity.postalCode === null || addressEntity.postalCode === '') {
                errors.addressEntity.postalCode = 'Pole jest wymagane';
                formIsValid = false;
            }

            if (addressEntity === null || addressEntity?.city === '' || addressEntity?.city === null) {
                errors.addressEntity.city = 'Pole jest wymagane';
                formIsValid = false;
            }
            if (isFakturownia && (fakturowniaPayableFrom === null || fakturowniaPayableFrom === '')) {
                errors.fakturowniaPayableFrom = 'Pole jest wymagane';
                formIsValid = false;
            }
            if (isFakturownia && !fakturowniaPrice) {
                errors.fakturowniaPrice = 'Pole jest wymagane';
                formIsValid = false;
            }
            if (isFakturownia && !numberRegex.test(fakturowniaPrice)) {
                errors.fakturowniaPrice = 'Wprowadź poprawną kwotę';
                formIsValid = false;
            }
            if (accountantDTOs?.[0]?.contactIdA && !changeAllowed) {
                alert("Nie można przypisać więcej klientów do księgowej/księgowego. Wymagana zmiana.")
                errors.accountantDTOs[0].contactIdA = 'Wymagana zmiana';
                formIsValid = false;
            }
        }

        else {
            // Walidacja cooperationHistoryDTO
            if (!errors.cooperationHistoryDTOs) {
                errors.cooperationHistoryDTOs = [{}];
            }

            if (cooperationHistoryDTOs && !cooperationStartsInFuture) {
                const startDate = cooperationHistoryDTOs[0] ? dayjs(cooperationHistoryDTOs[0].cooperationStartDate) : null;
                const endDate = cooperationHistoryDTOs[0] ? dayjs(cooperationHistoryDTOs[0].cooperationEndDate) : null;
                let endDateOfPreviousRecord = null;
                let suspensionEndDateOfPreviousRecord = null;

                if (cooperationHistoryDTOs?.[1]?.cooperationEndDate) {
                    endDateOfPreviousRecord = cooperationHistoryDTOs[1] ? dayjs(cooperationHistoryDTOs[1].cooperationEndDate) : null;
                }
                if (cooperationHistoryDTOs?.[1]?.suspensionEndDate) {
                    suspensionEndDateOfPreviousRecord = cooperationHistoryDTOs[1] ? dayjs(cooperationHistoryDTOs[1].suspensionEndDate) : null;
                }

                // Walidacja dla cooperationEndDate
                if (!suspended && (!cooperationHistoryDTOs[0].cooperationEndDate || cooperationHistoryDTOs[0].cooperationEndDate === '')) {
                    errors.cooperationHistoryDTOs[0].cooperationEndDate = 'Pole jest wymagane';
                    formIsValid = false;
                } else if (startDate && endDate && endDate.isBefore(startDate)) {
                    errors.cooperationHistoryDTOs[0].cooperationEndDate = "Data nie może być wcześniejsza niż data rozpoczęcia współpracy.";
                    formIsValid = false;
                } else if (
                    (endDateOfPreviousRecord && endDate.isBefore(endDateOfPreviousRecord)) ||
                    (endDateOfPreviousRecord && endDate.isSame(endDateOfPreviousRecord)) ||
                    (suspensionEndDateOfPreviousRecord && endDate.isBefore(suspensionEndDateOfPreviousRecord)) ||
                    (suspensionEndDateOfPreviousRecord && endDate.isSame(suspensionEndDateOfPreviousRecord))
                ) {
                    errors.cooperationHistoryDTOs[0].cooperationEndDate = "Data nie może wchodzić w zakres dat zakończonej/zawieszonej współpracy.";
                    formIsValid = false;
                }

                // Walidacja dla suspensionStartDate
                if (suspended && !suspensionEndDateInFuture && (!cooperationHistoryDTOs[0].suspensionStartDate || cooperationHistoryDTOs[0].suspensionStartDate === '')) {
                    errors.cooperationHistoryDTOs[0].suspensionStartDate = 'Pole jest wymagane';
                    formIsValid = false;
                } else if (startDate && cooperationHistoryDTOs[0].suspensionStartDate && dayjs(cooperationHistoryDTOs[0].suspensionStartDate).isBefore(startDate)) {
                    errors.cooperationHistoryDTOs[0].suspensionStartDate = "Data nie może być wcześniejsza niż data rozpoczęcia współpracy.";
                    formIsValid = false;
                } else if (
                    (endDateOfPreviousRecord && dayjs(cooperationHistoryDTOs[0].suspensionStartDate).isBefore(endDateOfPreviousRecord)) ||
                    (endDateOfPreviousRecord && dayjs(cooperationHistoryDTOs[0].suspensionStartDate).isSame(endDateOfPreviousRecord)) ||
                    (suspensionEndDateOfPreviousRecord && dayjs(cooperationHistoryDTOs[0].suspensionStartDate).isBefore(suspensionEndDateOfPreviousRecord)) ||
                    (suspensionEndDateOfPreviousRecord && dayjs(cooperationHistoryDTOs[0].suspensionStartDate).isSame(suspensionEndDateOfPreviousRecord))
                ) {
                    errors.cooperationHistoryDTOs[0].suspensionStartDate = "Data nie może wchodzić w zakres dat zakończonej/zawieszonej współpracy.";
                    formIsValid = false;
                }

                // Walidacja dla reasonForTerminatingCooperationId
                if (!suspensionEndDateInFuture && (cooperationHistoryDTOs[0].reasonForTerminatingCooperationId === '' || cooperationHistoryDTOs[0].reasonForTerminatingCooperationId === null)) {
                    errors.cooperationHistoryDTOs[0].reasonForTerminatingCooperationId = 'Pole jest wymagane';
                    formIsValid = false;
                }
            }
        }

        // Ustawianie błędów na końcu funkcji
        setErrors(errors);
        return formIsValid;
    };


    const validateField = (name, value) => {
        let isValid = true;
        const newErrors = _.cloneDeep(errors);

        if (!name.endsWith("gmail") && name !== "clientPackageDTOs[0].endDate" && name !== "clientTariffDTOs[0].endDate" && name !== "accountantDTOs[0].endDate" && (value === null || value.length === 0) && name !== "businessDesc" && name !== "tradersComments" && name !== "fakturowniaPrice" && name !== "accountManagerId") {
            _.set(newErrors, name, "Pole nie może być puste.");
        } else {
            if (name === "accountantDTOs[0].startDate") {
                const startDate = dayjs(value);
                const endDate = accountantDTOs[0] ? dayjs(accountantDTOs[0].endDate) : null;
                const endDateOfPreviousElement = accountantDTOs[1] ? dayjs(accountantDTOs[1].endDate) : null;

                if (endDate && endDate.isBefore(startDate)) {
                    _.set(newErrors, name, "Data początkowa nie może być późniejsza niż data końcowa");
                    isValid = false;
                } else if (endDateOfPreviousElement !== null && (endDateOfPreviousElement.isAfter(startDate) || endDateOfPreviousElement.isSame(startDate, 'month'))) {
                    _.set(newErrors, name, "Data początkowa musi być późniejsza niż data końcowa poprzedniego wiersza.");
                    isValid = false;
                }
                else {
                    _.unset(newErrors, name);
                    _.unset(newErrors, 'accountantDTOs[0].endDate');
                }
            }
            else if (name === "accountantDTOs[0].endDate") {
                const startDate = accountantDTOs[0] ? dayjs(accountantDTOs[0].startDate) : null;
                const endDate = dayjs(value);

                if (startDate && endDate.isBefore(startDate)) {
                    _.set(newErrors, name, "Data końcowa nie może być wcześniejsza niż data początkowa.");
                    isValid = false;
                } else {
                    _.unset(newErrors, name);
                    _.unset(newErrors, 'accountantDTOs[0].startDate');
                }
            }
            else if (name === "clientPackageDTOs[0].startDate") {
                const startDate = dayjs(value);
                const endDate = clientPackageDTOs[0] ? dayjs(clientPackageDTOs[0].endDate) : null;
                const endDateOfPreviousElement = clientPackageDTOs[1] ? dayjs(clientPackageDTOs[1].endDate) : null;

                if (endDate && endDate.isBefore(startDate)) {
                    _.set(newErrors, name, "Data początkowa nie może być późniejsza niż data końcowa");
                    isValid = false;
                } else if (endDateOfPreviousElement !== null && (endDateOfPreviousElement.isAfter(startDate) || endDateOfPreviousElement.isSame(startDate, 'month'))) {
                    _.set(newErrors, name, "Data początkowa musi być późniejsza niż data końcowa poprzedniego wiersza.");
                    isValid = false;
                } else {
                    _.unset(newErrors, name);
                    _.unset(newErrors, 'clientPackageDTOs[0].endDate');
                }
            }
            else if (name === "clientPackageDTOs[0].endDate") {
                const startDate = clientPackageDTOs[0] ? dayjs(clientPackageDTOs[0].startDate) : null;
                const endDate = dayjs(value);

                if (startDate && endDate.isBefore(startDate)) {
                    _.set(newErrors, name, "Data końcowa nie może być wcześniejsza niż data początkowa.");
                    isValid = false;
                } else {
                    _.unset(newErrors, name);
                    _.unset(newErrors, 'clientPackageDTOs[0].startDate');
                }
            }
            else if (name === "clientTariffDTOs[0].startDate") {
                const startDate = dayjs(value);
                const endDate = clientTariffDTOs[0] ? dayjs(clientTariffDTOs[0].endDate) : null;
                const endDateOfPreviousElement = clientTariffDTOs[1] ? dayjs(clientTariffDTOs[1].endDate) : null;

                if (endDate && endDate.isBefore(startDate)) {
                    _.set(newErrors, name, "Data początkowa nie może być późniejsza niż data końcowa");
                    isValid = false;
                } else if (endDateOfPreviousElement !== null && (endDateOfPreviousElement.isAfter(startDate) || endDateOfPreviousElement.isSame(startDate, 'month'))) {
                    _.set(newErrors, name, "Data początkowa musi być późniejsza niż data końcowa poprzedniego wiersza.");
                    isValid = false;
                } else {
                    _.unset(newErrors, name);
                    _.unset(newErrors, 'clientTariffDTOs[0].endDate');
                }
            }
            else if (name === "clientTariffDTOs[0].endDate") {
                const startDate = clientTariffDTOs[0] ? dayjs(clientTariffDTOs[0].startDate) : null;
                const endDate = dayjs(value);

                if (startDate && endDate.isBefore(startDate)) {
                    _.set(newErrors, name, "Data końcowa nie może być wcześniejsza niż data początkowa.");
                    isValid = false;
                } else {
                    _.unset(newErrors, name);
                    _.unset(newErrors, 'clientTariffDTOs[0].startDate');
                }
            }
            else if (name.endsWith("].number")) {
                if (!phoneNumberRegex.test(value)) {
                    _.set(newErrors, name, "Wprowadź poprawny numer telefonu");
                } else {
                    _.unset(newErrors, name); // Usunięcie błędu
                }
            }
            else if (name === "addressEntity.postalCode") {
                if (!postalCodeRegex.test(value)) {
                    _.set(newErrors, name, "Wprowadź poprawny kod pocztowy");
                } else {
                    _.unset(newErrors, name); // Usunięcie błędu
                }
            }
            else if (name.endsWith("emailAddress") || name === "invoiceEmail") {
                if (!emailRegex.test(value)) {
                    _.set(newErrors, name, "Wprowadź poprawny adres e-mail.");
                } else {
                    _.unset(newErrors, name); // Usunięcie błędu
                }
            }
            else if (name === "nip") {
                if (!nipRegex.test(value)) {
                    _.set(newErrors, name, "Wprowadź poprawny numer NIP");
                } else {
                    _.unset(newErrors, name); // Usunięcie błędu
                }
            }
            else if (name === "krs") {
                if (legalFormId !== 1 && !krsRegex.test(value)) {
                    _.set(newErrors, name, "Wprowadź poprawny numer KRS");
                } else {
                    _.unset(newErrors, name); // Usunięcie błędu
                }
            }
            else if (name === "fakturowniaPrice") {
                if (!numberRegex.test(value)) {
                    _.set(newErrors, name, "Wprowadź poprawny numer");
                } else {
                    _.unset(newErrors, name); // Usunięcie błędu
                }
            }
            else if (name === 'accountantDTOs[0].contactIdA') {
                let accountant = activeAccountants?.find(accountant => accountant.key === value);
                if (accountant?.activeClients > accountant?.maxNumberOfClients) {
                    alert("Nie można przypisać więcej klientów do księgowej/księgowego. Wymagana zmiana.")
                    setChangeAllowed(false);
                    _.set(newErrors, name, "Wymagana zmiana");
                }
                else {
                    setChangeAllowed(true);
                    _.unset(newErrors, name); // Usunięcie błędu
                }
            } else if (name === "cooperationHistoryDTOs[0].cooperationEndDate") {
                const startDate = cooperationHistoryDTOs[0] ? dayjs(cooperationHistoryDTOs[0].cooperationStartDate) : null;
                const endDate = dayjs(value);
                let endDateOfPreviousRecord = null;
                let suspensionEndDateOfPreviousRecord = null;
                if (cooperationHistoryDTOs?.[1]?.cooperationEndDate) {
                    endDateOfPreviousRecord = cooperationHistoryDTOs[1] ? dayjs(cooperationHistoryDTOs[1].cooperationEndDate) : null;
                }
                if (cooperationHistoryDTOs?.[1]?.suspensionEndDate) {
                    suspensionEndDateOfPreviousRecord = cooperationHistoryDTOs[1] ? dayjs(cooperationHistoryDTOs[1].suspensionEndDate) : null;
                }
                if (startDate && endDate.isBefore(startDate)) {
                    _.set(newErrors, name, "Data nie może być wcześniejsza niż data rozpoczęcia współpracy.");
                    isValid = false;
                } else if ((endDateOfPreviousRecord && endDate.isBefore(endDateOfPreviousRecord)) ||
                    (endDateOfPreviousRecord && endDate.isSame(endDateOfPreviousRecord)) ||
                    (suspensionEndDateOfPreviousRecord && endDate.isBefore(suspensionEndDateOfPreviousRecord)) ||
                    (suspensionEndDateOfPreviousRecord && endDate.isSame(suspensionEndDateOfPreviousRecord))) {
                    _.set(newErrors, name, "Data nie może wchodzić w zakres dat zakończonej/zawieszonej współpracy.");
                    isValid = false;
                } else {
                    _.unset(newErrors, name);
                }
            } else if (name === "cooperationHistoryDTOs[0].suspensionStartDate") {
                const startDate = cooperationHistoryDTOs[0] ? dayjs(cooperationHistoryDTOs[0].cooperationStartDate) : null;
                const suspensionStartDate = dayjs(value);
                let endDateOfPreviousRecord = null;
                let suspensionEndDateOfPreviousRecord = null;
                if (cooperationHistoryDTOs?.[1]?.cooperationEndDate) {
                    endDateOfPreviousRecord = cooperationHistoryDTOs[1] ? dayjs(cooperationHistoryDTOs[1].cooperationEndDate) : null;
                }
                if (cooperationHistoryDTOs?.[1]?.suspensionEndDate) {
                    suspensionEndDateOfPreviousRecord = cooperationHistoryDTOs[1] ? dayjs(cooperationHistoryDTOs[1].suspensionEndDate) : null;
                }

                if (startDate && suspensionStartDate.isBefore(startDate)) {
                    _.set(newErrors, name, "Data nie może być wcześniejsza niż data rozpoczęcia współpracy.");
                    isValid = false;
                } else if (
                    (endDateOfPreviousRecord && suspensionStartDate.isBefore(endDateOfPreviousRecord)) ||
                    (endDateOfPreviousRecord && suspensionStartDate.isSame(endDateOfPreviousRecord)) ||
                    (suspensionEndDateOfPreviousRecord && suspensionStartDate.isBefore(suspensionEndDateOfPreviousRecord)) ||
                    (suspensionEndDateOfPreviousRecord && suspensionStartDate.isSame(suspensionEndDateOfPreviousRecord))
                ) {
                    _.set(newErrors, name, "Data nie może wchodzić w zakres dat zakończonej/zawieszonej współpracy.");
                    isValid = false;
                }
                else {
                    _.unset(newErrors, name);
                }
            }
            else if (name === "cooperationHistoryDTOs[1].suspensionEndDate") {
                const startDate = cooperationHistoryDTOs[1] ? dayjs(cooperationHistoryDTOs[1].suspensionStartDate) : null;
                const endDate = dayjs(value);
                if (startDate && endDate.isBefore(startDate)) {
                    _.set(newErrors, name, "Data nie może być wcześniejsza niż data zawieszenia.");
                    isValid = false;
                }
                else {
                    _.unset(newErrors, name);
                }
            }
            else if (isResume && name === "cooperationHistoryDTOs[0].cooperationStartDate") {
                const startDate = dayjs(value);
                let endDateOfPreviousRecord = null;

                if (cooperationHistoryDTOs?.[1]?.cooperationEndDate) {
                    endDateOfPreviousRecord = dayjs(cooperationHistoryDTOs[1].cooperationEndDate);
                }

                if (endDateOfPreviousRecord && (startDate.isBefore(endDateOfPreviousRecord) || startDate.isSame(endDateOfPreviousRecord))) {
                    _.set(newErrors, name, "Data nie może być wcześniejsza niż data zakończenia współpracy z poprzedniego okresu.");
                    isValid = false;
                } else {
                    _.unset(newErrors, name);
                }
            }
            else {
                _.unset(newErrors, name); // Usunięcie błędu dla innych pól
            }
        }
        setErrors(newErrors);
        return isValid;
    };

    const handleImport = async () => {
        setErrors({});

        if (!nip || nip.length < 10) {
            setErrors({ ...errors, nip: "NIP jest wymagany i musi mieć 10 znaków" });
            return;
        }

        try {
            const response = await fetch(urlClientsFakturownia + `?nip=${nip}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` // Zawiera token w nagłówkach
                }
            });

            if (!response.ok) {
                throw new Error(`Błąd podczas pobierania danych z backendu: ${response.status}`);
            }

            const clients = await response.json();

            if (clients.length === 0) {
                setErrors({ ...errors, nip: "Nie znaleziono klienta z podanym NIP" });
                return;
            }

            const client = clients[0]; // Pierwszy klient z wyniku

            // Uzupełnij dane w formularzu
            setFormData((prevState) => {
                const newState = { ...prevState };

                _.set(newState, "companyName", client.name || "");
                _.set(newState, "companyWorkingName", CommonFunctions.removeLegalForm(client.name || ""));
                _.set(newState, "addressEntity.street", client.street || "");
                _.set(newState, "addressEntity.postalCode", client.post_code || "");
                _.set(newState, "addressEntity.city", client.city || "");
                _.set(newState, "invoiceEmail", client.email || "");

                return newState;
            });

            console.log("Dane klienta zaimportowane pomyślnie:", client);
        } catch (error) {
            console.error("Błąd podczas importowania danych:", error);
            setErrors({ ...errors, nip: "Wystąpił błąd podczas importu danych" });
        }
    };

    const fetchCompanyData = async () => {
        setErrors({});
        if (!nip || nip.length < 10) {
            setErrors({ ...errors, nip: "NIP jest wymagany i musi mieć 10 znaków" });
            return;
        }

        try {
            const response = await fetch(`${urlLivespace}/company?nip=${nip}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Błąd podczas pobierania danych z  CRM: ${response.status}`);
            }

            const data = await response.json();

            if (!data.data || !data.data.company || data.data.company.length === 0) {
                setErrors({ ...errors, nip: "Nie znaleziono klienta z podanym NIP" });
                return;
            }

            const client = data.data.company[0];

            setFormData((prevState) => {
                const newState = { ...prevState };

                _.set(newState, "companyName", client.name || "");
                _.set(newState, "companyWorkingName", CommonFunctions.removeLegalForm(client.name || ""));
                _.set(newState, "addressEntity.street", client.address_street || "");
                _.set(newState, "addressEntity.postalCode", client.address_postcode || "");
                _.set(newState, "addressEntity.city", client.address_city || "");

                // Mapowanie kontaktów do clientContactDTOs
                const mappedContacts = (client.contacts || []).map((contact) => ({
                    id: null,
                    name: `${contact.firstname} ${contact.lastname}`.trim(),
                    emails: (contact.emails || []).map((email) => ({
                        id: null,
                        emailAddress: email.value,
                        contactId: '',
                        temailTypeId: 21, // Można zmienić na dynamiczne przypisanie
                    })),
                    phones: (contact.phones || []).map((phone) => ({
                        id: null,
                        number: phone.number,
                        contactId: '',
                        tphoneTypeId: 21, // Można zmienić na dynamiczne przypisanie
                    })),
                    contactRoleTypeId: null,
                }));

                _.set(newState, "clientContactDTOs", mappedContacts);

                // Mapowanie dataset na pola w systemie
                if (client.dataset) {
                    _.set(newState, "businessDesc", client.dataset["9cd5fe0a-e45b-f5c3-b7a6-c801e0c852fe"] || ""); // Firma zajmuje się...
                    _.set(newState, "dateOfEntryInKRS", client.dataset["72044e27-065a-32fa-4ead-6f886ce01f5b"] || ""); // Data wpisu do KRS
                    _.set(newState, "firstFiscalYear", client.dataset["a68f6d1c-6e89-c64a-f285-0732ccf45b93"] || ""); // Pierwszy rok obrachunkowy
                    _.set(newState, "tradersComments", client.dataset["987ae82d-cfed-cd2f-98c4-33fcf5d024f5"] || ""); // Sugestie handlowego
                    const rawVat = client.dataset["4bac5aa7-8d09-c8ed-ac59-aa2c64fff2fc"];
                    _.set(newState, "vatStatus", rawVat?.toLowerCase() === "tak" ? "CZYNNY" : "");
                    _.set(newState, "isContinuationOfJDG", client.dataset["aa9e2e9b-2cdf-b19d-8348-9d413b7c05c0"] === "tak"); // kontynuacja JDG
                    _.set(newState, "isTransferOfAccounting", client.dataset["724905f8-63da-0bfd-8452-77ca6a276086"] === "tak"); // przeniesienie księgowości
                    _.set(newState, "isCompanyEstablishedBy7PM", client.dataset["9eaaa4e9-ba66-1595-a705-eceac8fd01a9"] === "tak"); // spółka zakładana przez 7PM
                    _.set(newState, "isContract", client.dataset["663edb18-c690-58a3-f8eb-24053ea64237"] != null); // czy istnieje umowa
                    _.set(newState, "cooperationHistoryDTOs[0].cooperationStartDate", client.dataset["1e752f86-419e-6660-2a4f-9a809e344e00"] || "");
                }

                // Mapowanie emaili 
                const gmail = client.dataset?.["c02e7184-2d4a-4077-2487-05876203ed99"] || ""; // e-mail do dysku Google
                const invoiceEmail = client.dataset?.["1326dc96-f4ea-88a6-9cc4-a6e124d4c02b"] || ""; // e-mail do faktur

                // Tworzymy nową listę emaili od zera
                let updatedEmails = [];

                const addEmailIfValid = (emailAddress, emailTypeId) => {
                    if (emailAddress) {
                        updatedEmails.push({ id: null, emailAddress, temailTypeId: emailTypeId });
                    }
                };

                addEmailIfValid(gmail, 11); // ID e-maila do Google Drive
                addEmailIfValid(invoiceEmail, 31); // ID e-maila do faktur

                _.set(newState, "emails", updatedEmails);

                // Mapowanie formy prawnej na ID
                const legalForm = client.dataset?.["0e46facd-11bc-ea24-9167-a112e586c38c"] || "";
                const legalFormMapping = {
                    "JDG": 1, // Jednoosobowa działalność gospodarcza
                    "Spółka z o.o.": 61,
                    "Prosta Spółka Akcyjna": 111,
                    "Fundacja": 91,
                    "Spółka komandytowa": 41,
                    "S.A.": 71
                };

                const legalFormId = legalFormMapping[legalForm] || null;

                _.set(newState, "legalFormId", legalFormId);

                // Mapowanie kto pozyskał klienta
                const invited = client.invited || [];

                const userMapping = {
                    "Marta Zatorska": 6181,
                    "Mirosław Płowiec": 341,
                    "Mateusz Stepien": 6201
                };

                const obtainedByContactId = invited
                    .filter(invitee => invitee.user_name) // Bierzemy tylko rekordy z user_name
                    .map(invitee => userMapping[invitee.user_name] || null) // Mapujemy user_name na ID
                    .find(id => id !== null) || null; // Wybieramy pierwszy znaleziony ID lub null

                _.set(newState, "obtainedByContactId", obtainedByContactId);


                return newState;
            });

            console.log("Updated State:", client);
        } catch (error) {
            console.error("Error fetching company data:", error);
        }
    };


    const [isSubmitting, setIsSubmitting] = useState(false);
    const isSubmittingRef = useRef(false);

    const handleSubmit = async () => {
        if (isSubmittingRef.current) return; // Jeśli trwa przetwarzanie, przerwij

        isSubmittingRef.current = true; // Blokujemy dalsze kliknięcia
        setIsSubmitting(true); // Aktualizacja stanu React

        let isValid = true;
        if (!isViewOnly) {
            isValid = validateFormOnSubmit();
        }

        if (isValid) {
            try {
                CommonFunctions.normalizeClientDates(formData);
                await handleFormSubmit();
            } finally {
                setTimeout(() => {
                    isSubmittingRef.current = false;
                    setIsSubmitting(false);  // Odblokowanie po 2 sek
                }, 2000); // 2-sekundowe opóźnienie
            }
        } else {
            alert("Uzupełnij poprawnie wymagane pola");
            isSubmittingRef.current = false; // Odblokowanie, jeśli formularz jest niepoprawny
            setIsSubmitting(false);
        }
        isAccountantSet.current = false;
    };


    const localHandleClose = () => {
        setChangeAllowed(true);
        handleClose();
        setErrors({});
        isAccountantSet.current = false;
    };

    const getStatus = () => ([
        {
            key: true,
            value: (() => {
                if (cooperationEndedInFuture || suspensionStartDateInFuture) {
                    return 'Wygasająca';
                }
                if (suspensionEndDateInFuture || cooperationStartsInFuture) {
                    return 'Oczekuje na start';
                }
                return 'Aktywna';
            })()
        },
        {
            key: false,
            value: suspended ? 'Zawieszona' : 'Zakończona'
        }
    ]);

    const getTrueFalse = () => ([
        { key: true, value: 'Tak' },
        { key: false, value: 'Nie' }
    ])

    const localOnChange = (e) => {
        const { name, value } = e.target;
        validateField(name, value);

        // Aktualizacja stanu formularza
        setFormData(prevState => {
            const newState = { ...prevState };

            // Handle 'legalFormId' field update
            if (name === 'legalFormId' && value === 1) {
                _.set(newState, 'firstFiscalYear', null);
            }

            // Handle 'isFakturownia' field update
            if (name === 'isFakturownia' && value === false) {
                _.set(newState, 'fakturowniaPayableFrom', null);
            }

            // Handle 'clientTariffDTOs[0].tclientTariffId' field update
            if (name === 'clientTariffDTOs[0].tclientTariffId') {
                setPackagesLocal(packages);
                if (id === null) {
                    _.set(newState, 'clientPackageDTOs[0].tpackageTypeId', '');
                    _.set(newState, 'clientPackageDTOs[0].startDate', '');
                    _.set(newState, 'clientTariffDTOs[0].startDate', '');
                }
            }

            // Set the new value for the changed field
            _.set(newState, name, value);

            return newState;
        });
    };

    const handleAddRepresentative = () => {
        setFormData(prevFormData => {
            const clientContacts = prevFormData.clientContactDTOs || [];
            const lastClient = clientContacts[clientContacts.length - 1];

            // Sprawdzenie, czy istnieje ostatni element i czy ma uzupełnione wymagane pola
            if (lastClient && (!lastClient.name)) {
                // Wyświetlenie komunikatu o błędzie
                alert("Proszę uzupełnić pole Reprezentant przed dodaniem nowego elementu");
                return { ...prevFormData };
            }

            // Dodanie nowego elementu, jeśli wszystkie pola ostatniego elementu są uzupełnione
            return {
                ...prevFormData,
                clientContactDTOs: [
                    ...clientContacts, // Zachowanie istniejących elementów
                    {
                        id: null,
                        name: '',
                        emails: [
                            {
                                id: null,
                                emailAddress: '',
                                contactId: null,
                                temailTypeId: 21
                            }
                        ],
                        phones: [
                            {
                                id: null,
                                number: '',
                                contactId: null,
                                tphoneTypeId: 21
                            }
                        ],
                    }
                ],
            };
        });
    };

    const handleEmailChange = (e, emailTypeId) => {
        const { name, value } = e.target;
        validateField(name, value);
        const newEmailAddress = value;

        setFormData(prevFormData => {
            let updatedEmails = [...(prevFormData.emails || [])];

            if (updatedEmails.length === 1 && updatedEmails[0].id === null && updatedEmails[0].temailTypeId === "") {
                updatedEmails = [{ id: null, emailAddress: newEmailAddress, temailTypeId: emailTypeId }];
            } else {
                const existingEmail = updatedEmails.find(email => email.temailTypeId === emailTypeId);
                if (existingEmail) {
                    updatedEmails = updatedEmails.map(email =>
                        email.temailTypeId === emailTypeId
                            ? { ...email, emailAddress: newEmailAddress }
                            : email
                    );
                } else {
                    updatedEmails.push({ id: null, emailAddress: newEmailAddress, temailTypeId: emailTypeId });
                }
            }
            return { ...prevFormData, emails: updatedEmails };
        });
    };

    const handleRemoveRepresentative = () => {
        setFormData(prevFormData => ({
            ...prevFormData,
            clientContactDTOs: (prevFormData.clientContactDTOs || []).slice(0, -1),
        }));
    };

    const handleAddNewTariff = () => {
        setFormData(prevFormData => {
            const tariffsLocal = prevFormData.clientTariffDTOs || [];
            const lastTariff = tariffsLocal[0];

            // Sprawdzenie, czy istnieje ostatni element i czy ma uzupełnione wymagane pola
            if (lastTariff && (!lastTariff.startDate || !lastTariff.endDate || !lastTariff.tclientTariffId)) {
                // Wyświetlenie komunikatu o błędzie (możesz użyć alertu lub innego mechanizmu do wyświetlania komunikatów)
                alert("Proszę uzupełnić prawidłowo wszystkie pola przed dodaniem nowego elementu.");
                return { ...prevFormData };
            }

            // Sprawdzenie, czy data końcowa nie jest wcześniejsza niż data początkowa
            if (lastTariff && new Date(lastTariff.endDate) < new Date(lastTariff.startDate)) {
                alert("Proszę uzupełnić prawidłowo wszystkie pola przed dodaniem nowego elementu.");
                return { ...prevFormData };
            }

            // Dodanie nowego elementu na początek listy, przesuwając poprzedni element w dół
            tariffsLocal.unshift({
                startDate: '',
                endDate: '',
                tclientTariffId: null,
            });

            return {
                ...prevFormData,
                clientTariffDTOs: tariffsLocal
            };
        });
    };

    const handleRemoveLastTariffListElement = () => {
        setErrors((prevErrors) => unsetErrors(prevErrors, 'clientTariffDTOs[0]'));
        setFormData((prevFormData) => {
            const updatedElements = [...(prevFormData.clientTariffDTOs || [])];
            updatedElements.shift();
            return { ...prevFormData, clientTariffDTOs: updatedElements };
        });
    };


    const handleAddNewPackage = () => {
        setFormData(prevFormData => {
            const packagesLocal = prevFormData.clientPackageDTOs || [];
            const lastPackage = packagesLocal[0];

            // Sprawdzenie, czy istnieje ostatni element i czy ma uzupełnione wymagane pola
            if (lastPackage && (!lastPackage.startDate || !lastPackage.endDate || !lastPackage.tpackageTypeId)) {
                // Wyświetlenie komunikatu o błędzie (możesz użyć alertu lub innego mechanizmu do wyświetlania komunikatów)
                alert("Proszę uzupełnić wszystkie pola przed dodaniem nowego elementu.");
                return { ...prevFormData };
            }

            // Sprawdzenie, czy istnieje ostatni element i czy ma uzupełnione wymagane pola
            if (lastPackage && new Date(lastPackage.endDate) < new Date(lastPackage.startDate)) {
                // Wyświetlenie komunikatu o błędzie (możesz użyć alertu lub innego mechanizmu do wyświetlania komunikatów)
                alert("Proszę uzupełnić prawidłowo wszystkie pola przed dodaniem nowego elementu.");
                return { ...prevFormData };
            }

            // Dodanie nowego elementu na początek listy, przesuwając poprzedni element w dół
            packagesLocal.unshift({
                startDate: '',
                endDate: '',
                tpackageTypeId: null,
            });

            return {
                ...prevFormData,
                clientPackageDTOs: packagesLocal
            };
        });
    };

    const handleRemoveLastPackageListElement = () => {
        setErrors((prevErrors) => unsetErrors(prevErrors, 'clientPackageDTOs[0]'));
        setFormData((prevFormData) => {
            const updatedElements = [...(prevFormData.clientPackageDTOs || [])];
            updatedElements.shift();
            return { ...prevFormData, clientPackageDTOs: updatedElements };
        });
    };

    const handleDateChange = (name, value) => {
        validateField(name, value)
        // Sprawdź, czy wartość jest datą w formacie YYYY-MM
        const datePattern = /^\d{4}-\d{2}$/;
        if (datePattern.test(value)) {
            // Dodaj '-01' do daty, aby uzyskać format YYYY-MM-DD
            value = `${value}-01`;
        }
        const datePatternYearOnly = /^\d{4}$/;
        if (datePatternYearOnly.test(value)) {
            // Dodaj '-01-01' do daty, aby uzyskać format YYYY-MM-DD
            value = `${value}-01-01`;
        }
        setFormData(prevState => {
            const newState = { ...prevState };
            // Ustawienie wartości dla innych pól
            _.set(newState, name, value);
            return newState;
        });
    };

    const handleCooperationState = (isEnded, isSuspended, isResume) => {
        let newActiveState, newCooperationEndedState;

        //test
        if (active === true && !isResume) {
            newActiveState = false;
            if (isEnded) {
                newCooperationEndedState = true;
                setCooperationEndedClicked(true);
                setCooperationSuspendedClicked(false);
                setCooperationEnded(true);
                setIsResume(false);
                // suspended is now derived from cooperationStatus
            }
            else if (isSuspended) {
                newCooperationEndedState = false;
                setCooperationSuspendedClicked(true);
                setCooperationEndedClicked(false);
                setIsResume(false);
                // suspended is now derived from cooperationStatus
                setCooperationEnded(false);
            }
            let errors = {};
            setErrors(errors);
        } else {
            newCooperationEndedState = false;
            newActiveState = true;
            setCooperationSuspendedClicked(false);
            setCooperationEndedClicked(false);
            setIsResume(false);
        }

        // Aktualizacja stanów
        setCooperationEnded(newCooperationEndedState);
        // active is derived from formData.isActive which is set below

        if (isResume) {
            setIsResume(true);
            const newCooperationStartDate = isResume && !suspended ? null : cooperationHistoryDTOs[0].cooperationStartDate;
            const newCooperationHistory = {
                cooperationStartDate: newCooperationStartDate,
                cooperationEndDate: null,
                suspensionStartDate: null,
                reasonForTerminatingCooperationId: '',
                suspended: false,
                ended: false,
                contactId: id
            };

            setFormData(prevState => {
                const newState = { ...prevState };
                _.set(newState, 'isActive', newActiveState);
                _.set(newState, 'cooperationStatus', 'ACTIVE');
                newState.cooperationHistoryDTOs.unshift(newCooperationHistory);
                return newState;
            });

            setCooperationHistoryList(prevList => {
                const newList = JSON.parse(JSON.stringify(prevList));
                newList.unshift(newCooperationHistory);
                return newList;
            });
        } else {
            // Aktualizacja stanu formularza
            setFormData(prevState => {
                const newState = { ...prevState };
                _.set(newState, 'isActive', newActiveState);
                _.set(newState, 'cooperationHistoryDTOs[0].cooperationEndDate', null);
                _.set(newState, 'cooperationHistoryDTOs[0].suspensionStartDate', null);
                _.set(newState, 'cooperationHistoryDTOs[0].reasonForTerminatingCooperationId', '');
                _.set(newState, 'cooperationHistoryDTOs[0].suspended', isSuspended);
                _.set(newState, 'cooperationHistoryDTOs[0].ended', newCooperationEndedState);
                if (isEnded) {
                    _.set(newState, 'cooperationStatus', 'ENDED');
                } else if (isSuspended) {
                    _.set(newState, 'cooperationStatus', 'SUSPENDED');
                } else {
                    _.set(newState, 'cooperationStatus', 'ACTIVE');
                }
                return newState;
            });
        }
    };

    const handleOpenEndDialog = () => {
        console.log("handleOpenEndDialog called!");
        setLocalEndDate(cooperationHistoryDTOs?.[0]?.cooperationEndDate || '');
        setLocalReasonId(cooperationHistoryDTOs?.[0]?.reasonForTerminatingCooperationId || '');
        setLocalErrors({});
        setOpenEndDialog(true);
    };

    const handleOpenSuspendDialog = () => {
        setLocalStartDate(cooperationHistoryDTOs?.[0]?.suspensionStartDate || '');
        setLocalReasonId(cooperationHistoryDTOs?.[0]?.reasonForTerminatingCooperationId || '');
        setLocalErrors({});
        setOpenSuspendDialog(true);
    };

    const submitEndCooperation = () => {
        let errs = {};
        let isValid = true;
        let finalEndDate = localEndDate;

        if (!finalEndDate || finalEndDate === '') {
            errs.endDate = 'Pole jest wymagane';
            isValid = false;
        } else {
            const datePattern = /^\d{4}-\d{2}$/;
            if (datePattern.test(finalEndDate)) {
                finalEndDate = `${finalEndDate}-01`;
            }
            const startDate = cooperationHistoryDTOs?.[0] ? dayjs(cooperationHistoryDTOs[0].cooperationStartDate) : null;
            const endDate = dayjs(finalEndDate);
            let endDateOfPreviousRecord = null;
            let suspensionEndDateOfPreviousRecord = null;

            if (cooperationHistoryDTOs?.[1]?.cooperationEndDate) {
                endDateOfPreviousRecord = dayjs(cooperationHistoryDTOs[1].cooperationEndDate);
            }
            if (cooperationHistoryDTOs?.[1]?.suspensionEndDate) {
                suspensionEndDateOfPreviousRecord = dayjs(cooperationHistoryDTOs[1].suspensionEndDate);
            }

            if (startDate && endDate.isBefore(startDate)) {
                errs.endDate = "Data nie może być wcześniejsza niż data rozpoczęcia współpracy.";
                isValid = false;
            } else if (
                (endDateOfPreviousRecord && (endDate.isBefore(endDateOfPreviousRecord) || endDate.isSame(endDateOfPreviousRecord))) ||
                (suspensionEndDateOfPreviousRecord && (endDate.isBefore(suspensionEndDateOfPreviousRecord) || endDate.isSame(suspensionEndDateOfPreviousRecord)))
            ) {
                errs.endDate = "Data nie może wchodzić w zakres dat zakończonej/zawieszonej współpracy.";
                isValid = false;
            }
        }

        if (localReasonId === '' || localReasonId === null) {
            errs.reasonId = 'Pole jest wymagane';
            isValid = false;
        }

        if (!isValid) {
            console.log("Validation errors in submitEndCooperation:", errs);
            setLocalErrors(errs);
            return;
        }

        setLocalEndDate(finalEndDate);

        setFormData(prevState => {
            const newState = { ...prevState };
            const isFutureOrCurrent = !dayjs(finalEndDate).isBefore(dayjs(), 'month');
            const newStatus = isFutureOrCurrent ? 'FUTURE_END' : 'ENDED';
            const newActive = isFutureOrCurrent;
            _.set(newState, 'isActive', newActive);
            _.set(newState, 'cooperationStatus', newStatus);
            _.set(newState, 'cooperationHistoryDTOs[0].cooperationEndDate', finalEndDate);
            _.set(newState, 'cooperationHistoryDTOs[0].reasonForTerminatingCooperationId', localReasonId);
            _.set(newState, 'cooperationHistoryDTOs[0].ended', !isFutureOrCurrent);
            _.set(newState, 'cooperationHistoryDTOs[0].suspended', false);
            return newState;
        });

        setCooperationHistoryList(prevList => {
            const newList = JSON.parse(JSON.stringify(prevList));
            if (newList.length > 0) {
                const isFutureOrCurrent = !dayjs(finalEndDate).isBefore(dayjs(), 'month');
                const latest = newList[0];
                latest.cooperationEndDate = finalEndDate;
                latest.reasonForTerminatingCooperationId = localReasonId;
                latest.ended = !isFutureOrCurrent;
                latest.suspended = false;
            }
            return newList;
        });

        setOpenEndDialog(false);
    };

    const submitSuspendCooperation = () => {
        let errs = {};
        let isValid = true;
        let finalStartDate = localStartDate;

        if (!finalStartDate || finalStartDate === '') {
            errs.startDate = 'Pole jest wymagane';
            isValid = false;
        } else {
            const datePattern = /^\d{4}-\d{2}$/;
            if (datePattern.test(finalStartDate)) {
                finalStartDate = `${finalStartDate}-01`;
            }
            const startDate = cooperationHistoryDTOs?.[0] ? dayjs(cooperationHistoryDTOs[0].cooperationStartDate) : null;
            const suspensionStart = dayjs(finalStartDate);
            let endDateOfPreviousRecord = null;
            let suspensionEndDateOfPreviousRecord = null;

            if (cooperationHistoryDTOs?.[1]?.cooperationEndDate) {
                endDateOfPreviousRecord = dayjs(cooperationHistoryDTOs[1].cooperationEndDate);
            }
            if (cooperationHistoryDTOs?.[1]?.suspensionEndDate) {
                suspensionEndDateOfPreviousRecord = dayjs(cooperationHistoryDTOs[1].suspensionEndDate);
            }

            if (startDate && suspensionStart.isBefore(startDate)) {
                errs.startDate = "Data nie może być wcześniejsza niż data rozpoczęcia współpracy.";
                isValid = false;
            } else if (
                (endDateOfPreviousRecord && (suspensionStart.isBefore(endDateOfPreviousRecord) || suspensionStart.isSame(endDateOfPreviousRecord))) ||
                (suspensionEndDateOfPreviousRecord && (suspensionStart.isBefore(suspensionEndDateOfPreviousRecord) || suspensionStart.isSame(suspensionEndDateOfPreviousRecord)))
            ) {
                errs.startDate = "Data nie może wchodzić w zakres dat zakończonej/zawieszonej współpracy.";
                isValid = false;
            }
        }

        if (localReasonId === '' || localReasonId === null) {
            errs.reasonId = 'Pole jest wymagane';
            isValid = false;
        }

        if (!isValid) {
            console.log("Validation errors in submitSuspendCooperation:", errs);
            setLocalErrors(errs);
            return;
        }

        setLocalStartDate(finalStartDate);

        setFormData(prevState => {
            const newState = { ...prevState };
            const isFuture = dayjs(finalStartDate).isAfter(dayjs(), 'month');
            const newStatus = isFuture ? 'FUTURE_SUSPENSION' : 'SUSPENDED';
            const newActive = isFuture;
            _.set(newState, 'isActive', newActive);
            _.set(newState, 'cooperationStatus', newStatus);
            _.set(newState, 'cooperationHistoryDTOs[0].suspensionStartDate', finalStartDate);
            _.set(newState, 'cooperationHistoryDTOs[0].reasonForTerminatingCooperationId', localReasonId);
            _.set(newState, 'cooperationHistoryDTOs[0].suspended', !isFuture);
            _.set(newState, 'cooperationHistoryDTOs[0].ended', false);
            return newState;
        });

        setCooperationHistoryList(prevList => {
            const newList = JSON.parse(JSON.stringify(prevList));
            if (newList.length > 0) {
                const isFuture = dayjs(finalStartDate).isAfter(dayjs(), 'month');
                const latest = newList[0];
                latest.suspensionStartDate = finalStartDate;
                latest.reasonForTerminatingCooperationId = localReasonId;
                latest.suspended = !isFuture;
                latest.ended = false;
            }
            return newList;
        });

        setOpenSuspendDialog(false);
    };

    const handleOpenResumeDialog = () => {
        if (cooperationStatus === "FUTURE_END") {
            alert("Nie można wznowić współpracy, która jeszcze się nie zakończyła (w statusie wygasająca). Możliwe jest jedynie jej anulowanie.");
            return;
        }
        setLocalResumeDate('');
        setLocalErrors({});
        setOpenResumeDialog(true);
    };

    const submitResumeCooperation = () => {
        if (cooperationStatus === "FUTURE_END") {
            return;
        }
        let errs = {};
        let isValid = true;
        let finalResumeDate = localResumeDate;

        if (!finalResumeDate || finalResumeDate === '') {
            errs.resumeDate = 'Pole jest wymagane';
            isValid = false;
        } else {
            const datePattern = /^\d{4}-\d{2}$/;
            if (datePattern.test(finalResumeDate)) {
                finalResumeDate = `${finalResumeDate}-01`;
            }

            if (suspended) {
                const suspensionStart = cooperationHistoryDTOs?.[0] ? dayjs(cooperationHistoryDTOs[0].suspensionStartDate) : null;
                const resumeDateVal = dayjs(finalResumeDate);

                if (suspensionStart && resumeDateVal.isBefore(suspensionStart)) {
                    errs.resumeDate = "Data nie może być wcześniejsza niż data zawieszenia.";
                    isValid = false;
                }
            } else {
                const previousEndDate = cooperationHistoryDTOs?.[0] ? dayjs(cooperationHistoryDTOs[0].cooperationEndDate) : null;
                const resumeDateVal = dayjs(finalResumeDate);

                if (previousEndDate && (resumeDateVal.isBefore(previousEndDate) || resumeDateVal.isSame(previousEndDate))) {
                    errs.resumeDate = "Data nie może być wcześniejsza niż data zakończenia współpracy z poprzedniego okresu.";
                    isValid = false;
                }
            }
        }

        if (!isValid) {
            console.log("Validation errors in submitResumeCooperation:", errs);
            setLocalErrors(errs);
            return;
        }

        setLocalResumeDate(finalResumeDate);
        setIsResume(true);
        const newActiveState = true;
        setCooperationSuspendedClicked(false);
        setCooperationEndedClicked(false);
        setCooperationEnded(false);

        if (suspended) {
            setFormData(prevState => {
                const newState = { ...prevState };
                _.set(newState, 'isActive', newActiveState);
                _.set(newState, 'cooperationStatus', 'ACTIVE');

                const prevRecord = newState.cooperationHistoryDTOs[0];
                prevRecord.suspensionEndDate = finalResumeDate;

                const newCooperationHistory = {
                    cooperationStartDate: prevRecord.cooperationStartDate,
                    cooperationEndDate: null,
                    suspensionStartDate: null,
                    reasonForTerminatingCooperationId: '',
                    suspended: false,
                    ended: false,
                    contactId: id
                };

                newState.cooperationHistoryDTOs.unshift(newCooperationHistory);
                return newState;
            });

            setCooperationHistoryList(prevList => {
                const newList = JSON.parse(JSON.stringify(prevList));
                if (newList.length > 0) {
                    newList[0].suspensionEndDate = finalResumeDate;
                }
                const newCooperationHistory = {
                    cooperationStartDate: newList[0]?.cooperationStartDate || null,
                    cooperationEndDate: null,
                    suspensionStartDate: null,
                    reasonForTerminatingCooperationId: '',
                    suspended: false,
                    ended: false,
                    contactId: id
                };
                newList.unshift(newCooperationHistory);
                return newList;
            });
        } else {
            const newCooperationHistory = {
                cooperationStartDate: finalResumeDate,
                cooperationEndDate: null,
                suspensionStartDate: null,
                reasonForTerminatingCooperationId: '',
                suspended: false,
                ended: false,
                contactId: id
            };

            setFormData(prevState => {
                const newState = { ...prevState };
                _.set(newState, 'isActive', newActiveState);
                _.set(newState, 'cooperationStatus', 'ACTIVE');
                newState.cooperationHistoryDTOs.unshift(newCooperationHistory);
                return newState;
            });

            setCooperationHistoryList(prevList => {
                const newList = JSON.parse(JSON.stringify(prevList));
                newList.unshift(newCooperationHistory);
                return newList;
            });
        }

        setOpenResumeDialog(false);
    };

    const handleCancelCooperation = () => {
        setFormData(prevState => {
            const newState = { ...prevState };
            _.set(newState, 'isActive', true);
            _.set(newState, 'cooperationStatus', 'ACTIVE');

            if (newState.cooperationHistoryDTOs && newState.cooperationHistoryDTOs.length > 0) {
                const latest = newState.cooperationHistoryDTOs[0];
                latest.cooperationEndDate = null;
                latest.suspensionStartDate = null;
                latest.suspensionEndDate = null;
                latest.resumptionDate = null;
                latest.reasonForTerminatingCooperationId = null;
                latest.reasonForTerminatingCooperation = null;
                latest.suspended = false;
                latest.ended = false;
            }
            return newState;
        });

        setCooperationHistoryList(prevList => {
            const newList = [...prevList];
            if (newList.length > 0) {
                const latest = newList[0];
                latest.cooperationEndDate = null;
                latest.suspensionStartDate = null;
                latest.suspensionEndDate = null;
                latest.resumptionDate = null;
                latest.reasonForTerminatingCooperationId = null;
                latest.reasonForTerminatingCooperation = null;
                latest.suspended = false;
                latest.ended = false;
            }
            return newList;
        });

        setCooperationEnded(false);
        setCooperationEndedClicked(false);
        setCooperationSuspendedClicked(false);
        setIsResume(false);
    };

    const handleAddNewAccountant = () => {
        setFormData(prevFormData => {
            const accountantsLocal = prevFormData.accountantDTOs || [];
            const lastAccountant = accountantsLocal[0];

            // Sprawdzenie, czy istnieje ostatni element i czy ma uzupełnione wymagane pola
            if (lastAccountant && (!lastAccountant.startDate || !lastAccountant.endDate || !lastAccountant.contactIdA)) {
                // Wyświetlenie komunikatu o błędzie (możesz użyć alertu lub innego mechanizmu do wyświetlania komunikatów)
                alert("Proszę uzupełnić prawidłowo wszystkie pola przed dodaniem nowego elementu.");
                return { ...prevFormData };
            }

            // Sprawdzenie, czy data końcowa nie jest wcześniejsza niż data początkowa
            if (lastAccountant && new Date(lastAccountant.endDate) < new Date(lastAccountant.startDate)) {
                alert("Proszę uzupełnić prawidłowo wszystkie pola przed dodaniem nowego elementu.");
                return { ...prevFormData };
            }

            if (lastAccountant) {
                lastAccountant.isCurrent = false;
            }
            // Dodanie nowego elementu na początek listy, przesuwając poprzedni element w dół
            accountantsLocal.unshift({
                id: null,
                isCurrent: true,
                contactIdA: '',
                startDate: '',
                endDate: '',
                relationshipTypeId: 11
            });

            return {
                ...prevFormData,
                accountantDTOs: accountantsLocal
            };
        });
    };
    const handleRemoveLastAccountantElement = () => {
        setErrors((prevErrors) => unsetErrors(prevErrors, 'accountantDTOs[0]'));
        setChangeAllowed(true);
        setFormData((prevFormData) => {
            const updatedElements = [...(prevFormData.accountantDTOs || [])];
            updatedElements.shift();
            return { ...prevFormData, accountantDTOs: updatedElements };
        });
    };

    const unsetErrors = (errors, element) => {
        const newErrors = _.cloneDeep(errors);
        _.unset(newErrors, element);
        return newErrors;
    };

    const downloadTransactions = async (clientId, format) => {
        try {
            const url = new URL(`${urlFizen}/transactions/download`);
            url.searchParams.append("format", format.toLowerCase());
            url.searchParams.append("clientId", clientId);

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error("Download failed:", errorText);
                throw new Error(`Failed to download transactions file: ${format}`);
            }

            // Pobieramy plik jako blob
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);

            // Tworzymy element <a> do pobrania
            const link = document.createElement("a");
            link.href = downloadUrl;

            // Nazwa pliku z nagłówka Content-Disposition lub domyślna
            const contentDisposition = response.headers.get("Content-Disposition");
            let fileName;

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?(.+)"?/);
                fileName = match?.[1] || `transactions.${format.toLowerCase()}`;
            } else {
                // Domyślne rozszerzenie w zależności od formatu
                switch (format.toLowerCase()) {
                    case "excel":
                        fileName = "wyciagi_bankowe_excel.zip";
                        break;
                    case "mt940":
                        fileName = "wyciagi_bankowe_mt940.zip";
                        break;
                    case "csv":
                        fileName = "wyciagi_bankowe_csv.zip";
                        break;
                    default:
                        fileName = `transactions.${format.toLowerCase()}`;
                }
            }

            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();

            // Sprzątanie
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);

        } catch (error) {
            console.error("Error downloading transactions:", error);
            alert(error.message);
        }
    };

    const getAccounts = async () => {
        const url = new URL(`${urlFizen}/accountDetails/${id}`);
        const response = await fetch(url, {
            method: "GET", // lub POST jeśli backend wymaga
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });

        const data = await response.json();
        setAccounts(data);
    };

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                // maxWidth="lg"
                fullScreen
            >
                <DialogTitle id="alert-dialog-title">
                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
                        <Grid item xs={10}>
                            <Typography variant="h5">
                                {id === 0 ? "Dodaj Klienta" : "Karta Klienta"}
                            </Typography>
                        </Grid>
                        <Grid item xs={2} style={{ textAlign: 'right' }}>
                            <IconButton onClick={handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                        </Grid>

                        <Grid item xs={2}>
                            <Button
                                href={clientPanelUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant="text"
                                style={{
                                    float: 'left',
                                    color: 'red',
                                    textDecoration: 'none'
                                }}
                            >
                                Lista faktur
                            </Button>
                        </Grid>

                        <Grid item xs={6}>
                            {/* Your content */}
                        </Grid>
                        <Grid item xs={2}>
                            <Button onClick={fetchCompanyData} disabled={isViewOnly} color="secondary" style={{ float: 'right' }}>
                                Importuj z CRM
                            </Button>
                        </Grid>
                        <Grid item xs={2}>
                            <Button color="primary" onClick={handleImport} disabled={isViewOnly} style={{ float: 'left' }}>
                                aktualizuj z Fakturowni
                            </Button>
                        </Grid>
                    </Grid>
                </DialogTitle>

                <Divider />
                <DialogContent>
                    <form>
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
                            <Grid item xs={12}>
                                <Div>{"Dane podstawowe"}</Div>
                            </Grid>
                            <Grid item xs={3}>
                                <DeferredTextField
                                    name="companyName"
                                    value={companyName}
                                    onChange={localOnChange}
                                    placeholder="Wprowadź nazwę firmy"
                                    label="Nazwa firmy"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    disabled={!disabledButton}
                                    error={!!errors.companyName}
                                    helperText={errors.companyName}
                                    InputProps={{
                                        style: { fontWeight: "bold", color: "#009cdc" },
                                        readOnly: isViewOnly
                                    }} />
                            </Grid>
                            <Grid item xs={3}>
                                <DeferredTextField
                                    name="companyWorkingName"
                                    value={companyWorkingName}
                                    onChange={localOnChange}
                                    placeholder="Wprowadź nazwę roboczą firmy"
                                    label="Nazwa robocza firmy"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    disabled={!disabledButton}
                                    error={!!errors.companyWorkingName}
                                    helperText={errors.companyWorkingName}
                                    InputProps={{
                                        style: { fontWeight: "bold", color: "#009cdc" },
                                        readOnly: isViewOnly
                                    }} />
                            </Grid>
                            <Grid item xs={2} >
                                <DeferredTextField
                                    name="nip"
                                    value={nip}
                                    onChange={localOnChange}
                                    placeholder="Wprowadź NIP"
                                    label="NIP"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    disabled={!disabledButton}
                                    error={!!errors.nip}
                                    helperText={errors.nip}
                                    InputProps={{
                                        style: { fontWeight: "bold" },
                                        readOnly: isViewOnly
                                    }} />
                            </Grid>
                            <Grid item xs={2} >
                                <DeferredTextField
                                    name="krs"
                                    value={krs || ''}
                                    onChange={localOnChange}
                                    placeholder="Wprowadź KRS"
                                    label="KRS"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    disabled={!disabledButton}
                                    error={!!errors.krs}
                                    helperText={errors.krs}
                                    InputProps={{
                                        style: { fontWeight: "bold" },
                                        readOnly: isViewOnly
                                    }} />
                            </Grid>
                            <Grid item xs={2} >
                                <Controls.Select
                                    name="isActive"
                                    label="Status współpracy"
                                    readOnly={true}
                                    isColor={true}
                                    isBoolean={true}
                                    value={active || cooperationStartsInFuture}
                                    onChange={localOnChange}
                                    options={getStatus()}
                                    variant="outlined"
                                    margin="dense"
                                    error={errors.active}
                                    InputProps={{
                                        readOnly: isViewOnly
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
                            <Grid item xs={6}>
                                <DeferredTextField
                                    name="addressEntity.street"
                                    value={addressEntity?.street}
                                    onChange={localOnChange}
                                    placeholder="Wprowadź ulicę i numer domu/lokalu"
                                    label="Ulica i numer domu/lokalu"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    disabled={!disabledButton}
                                    error={!!(errors.addressEntity && errors.addressEntity.street)}
                                    helperText={errors.addressEntity && errors.addressEntity.street}
                                    InputProps={{
                                        readOnly: isViewOnly
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3} >
                                <DeferredTextField
                                    name="addressEntity.postalCode"
                                    value={addressEntity?.postalCode}
                                    onChange={localOnChange}
                                    placeholder="Wprowadź kod pocztowy"
                                    label="Kod pocztowy"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    disabled={!disabledButton}
                                    error={!!(errors.addressEntity && errors.addressEntity.postalCode)}
                                    helperText={errors.addressEntity && errors.addressEntity.postalCode}
                                    InputProps={{
                                        readOnly: isViewOnly
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3} >
                                <DeferredTextField
                                    name="addressEntity.city"
                                    value={addressEntity?.city}
                                    onChange={localOnChange}
                                    placeholder="Wprowadź miasto"
                                    label="Miasto"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    disabled={!disabledButton}
                                    error={!!(errors.addressEntity && errors.addressEntity.city)}
                                    helperText={errors.addressEntity && errors.addressEntity.city}
                                    InputProps={{
                                        readOnly: isViewOnly
                                    }}
                                />
                            </Grid>
                            {id !== null && accountantDTOs && accountantDTOs.length > 0 && (
                                <>
                                    <Grid item xs={3}>
                                        <DeferredTextField
                                            name="accountant"
                                            value={currentAccountant}
                                            onChange={localOnChange}
                                            label="Obecna Księgowa/Księgowy"
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                            disabled={!disabledButton}
                                            InputProps={{
                                                readOnly: true
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <DeferredTextField
                                            name="supervisor"
                                            value={currentSupervisorName}
                                            onChange={localOnChange}
                                            label="Superwizor"
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                            disabled={!disabledButton}
                                            InputProps={{
                                                readOnly: true
                                            }} />
                                    </Grid>
                                </>
                            )}
                            <Grid item xs={6}>
                                <Controls.Select
                                    name="accountManagerId"
                                    label="Opiekun klienta"
                                    value={accountManagerId}
                                    readOnly={isViewOnly}
                                    disabled={!disabledButton}
                                    onChange={localOnChange}
                                    options={accountManagers}
                                    variant="outlined"
                                    margin="dense"
                                    error={errors.users}
                                />
                            </Grid>
                        </Grid>
                        <Box sx={{ m: '36px' }} />
                        <Divider />
                        <Box sx={{ m: '10px' }} />
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
                            <Grid item xs={12}>
                                <Div>{"Dane uzupełniające"}</Div>
                            </Grid>
                            <Grid item xs={6}>
                                <DeferredTextField
                                    name="additionalContact"
                                    value={additionalContact}
                                    onChange={localOnChange}
                                    placeholder="Wprowadź dodatkowy kontakt"
                                    label="Dodatkowy kontakt"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    disabled={!disabledButton}
                                    InputProps={{
                                        readOnly: isViewOnly
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <DeferredTextField
                                    name="uplSupervisor"
                                    value={uplSupervisor}
                                    onChange={localOnChange}
                                    placeholder="Wprowadź UPL-SUPERWIZOR"
                                    label="UPL-SUPERWIZOR"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    disabled={!disabledButton}
                                    InputProps={{
                                        readOnly: isViewOnly
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Box sx={{ m: '36px' }} />
                        <Divider />
                        <Box sx={{ m: '10px' }} />
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
                            <Grid item xs={12}>
                                <Div>{"Reprezentanci"}</Div>
                                <Box sx={{ m: '10px' }} />
                            </Grid>
                        </Grid>
                        {clientContacts && clientContacts.length > 0 && clientContacts.map((element, index) => (
                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
                                <Grid item xs={3}>
                                    <DeferredTextField
                                        name={`clientContactDTOs[${index}].name`}
                                        value={element.name}
                                        onChange={localOnChange}
                                        placeholder="Wprowadź imię i nazwisko reprezentanta"
                                        label="Reprezentant"
                                        variant="outlined"
                                        disabled={!disabledButton}
                                        margin="dense"
                                        fullWidth
                                        error={!!(errors.clientContactDTOs && errors.clientContactDTOs?.[index] && errors.clientContactDTOs[index].name)}
                                        helperText={errors.clientContactDTOs && errors.clientContactDTOs[index] ? errors.clientContactDTOs[index].name : undefined}
                                        InputProps={{
                                            style: { fontWeight: "bold" },
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <Controls.Select
                                        name={`clientContactDTOs[${index}].contactRoleTypeId`}
                                        label="Funkcja"
                                        value={element.contactRoleTypeId}
                                        disabled={!disabledButton}
                                        onChange={localOnChange}
                                        options={contactRoles}
                                        variant="outlined"
                                        margin="dense"
                                        error={!!(errors.clientContactDTOs && errors.clientContactDTOs[index] && errors.clientContactDTOs[index].contactRoleTypeId)}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <DeferredTextField
                                        name={`clientContactDTOs[${index}].emails[0].emailAddress`}
                                        value={element.emails && element.emails[0]?.emailAddress}
                                        onChange={localOnChange}
                                        placeholder="Wprowadź email"
                                        label="Email"
                                        disabled={!disabledButton}
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        error={!!(errors.clientContactDTOs && errors.clientContactDTOs[index] && errors.clientContactDTOs[index].emails && errors.clientContactDTOs[index].emails[0].emailAddress)}
                                        helperText={errors.clientContactDTOs && errors.clientContactDTOs[index] && errors.clientContactDTOs[index].emails ? errors.clientContactDTOs[index].emails[0].emailAddress : undefined}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <DeferredTextField
                                        name={`clientContactDTOs[${index}].phones[0].number`}
                                        value={element.phones && element.phones[0]?.number}
                                        onChange={localOnChange}
                                        placeholder="Wprowadź telefon"
                                        label="Telefon"
                                        disabled={!disabledButton}
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        error={!!(errors.clientContactDTOs && errors.clientContactDTOs[index] && errors.clientContactDTOs[index].phones && errors.clientContactDTOs[index].phones[0].number)}
                                        helperText={errors.clientContactDTOs && errors.clientContactDTOs[index] && errors.clientContactDTOs[index].phones ? errors.clientContactDTOs[index].phones[0].number : undefined}
                                    />
                                </Grid>
                            </Grid>
                        ))}
                        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={6} >
                                {clientContacts?.length > 1 && (
                                    <ConditionButton variant="contained" disabled={!disabledButton} onClick={handleRemoveRepresentative}>
                                        Usuń ostatni element
                                    </ConditionButton>
                                )}
                            </Grid>
                            <Grid item xs={6} >
                                <ConditionButton style={{ float: 'right' }} variant="contained" disabled={!disabledButton} color="secondary" onClick={handleAddRepresentative}>
                                    Dodaj reprezentanta
                                </ConditionButton>
                            </Grid>
                        </Grid>
                        <Box sx={{ m: '36px' }} />
                        <Divider />
                        <Box sx={{ m: '10px' }} />
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                            <Grid item xs={12}>
                                <Div>{"Dane do rozliczeń"}</Div>
                            </Grid>
                            <Grid item xs={6}>
                                <DeferredTextField
                                    name="gmail"
                                    value={gmail}
                                    onChange={(e) => handleEmailChange(e, 11)}
                                    placeholder="Wprowadź gmail"
                                    disabled={!disabledButton}
                                    label="Gmail do dysku Google"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    error={!!errors.gmail}
                                    helperText={errors.gmail}
                                    InputProps={{
                                        readOnly: isViewOnly
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <DeferredTextField
                                    name="invoiceEmail"
                                    value={invoiceEmail}
                                    onChange={(e) => handleEmailChange(e, 31)}
                                    placeholder="Wprowadź email"
                                    disabled={!disabledButton}
                                    label="E-mail do faktur"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    error={!!errors.invoiceEmail}
                                    helperText={errors.invoiceEmail}
                                    InputProps={{
                                        readOnly: isViewOnly
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Box sx={{ m: '56px' }} />
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                            <Grid item xs={2}>
                                <Controls.Checkbox
                                    name="isOptima"
                                    value={isOptima}
                                    disabled={!disabledButton || isViewOnly}
                                    onChange={localOnChange}
                                    label="Optima?"
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Controls.Checkbox
                                    name="isInsert"
                                    value={isInsert}
                                    disabled={!disabledButton || isViewOnly}
                                    onChange={localOnChange}
                                    label="Insert?"
                                />
                            </Grid>
                            <Grid item xs={8}>
                                <Controls.Checkbox
                                    name="isFakturownia"
                                    label="Płatna Fakturownia?"
                                    value={isFakturownia}
                                    disabled={!disabledButton || isViewOnly}
                                    onChange={localOnChange}
                                />
                            </Grid>
                        </Grid>
                        <Box sx={{ m: '16px' }} />
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                            {isFakturownia && (
                                <>
                                    <Grid item xs={6}>
                                        <Controls.MyDatePicker
                                            name="fakturowniaPayableFrom"
                                            label="Fakturownia płatna od"
                                            value={fakturowniaPayableFrom}
                                            disabled={!disabledButton}
                                            readOnly={isViewOnly}
                                            onChange={newValue => handleDateChange('fakturowniaPayableFrom', newValue)}
                                            error={!!errors.fakturowniaPayableFrom}
                                            helperText={errors.fakturowniaPayableFrom}
                                            format="YYYY-MM"
                                            views={["year", "month"]}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <DeferredTextField
                                            name="fakturowniaPrice"
                                            value={fakturowniaPrice}
                                            placeholder="Wprowadź kwotę"
                                            disabled={!disabledButton}
                                            label="Cena za fakturownie"
                                            variant="outlined"
                                            margin="dense"
                                            onChange={(e) => localOnChange(e)}
                                            fullWidth
                                            error={!!errors.fakturowniaPrice}
                                            helperText={errors.fakturowniaPrice}
                                            inputProps={{
                                                readOnly: isViewOnly
                                            }}
                                        />
                                    </Grid>
                                    <Box sx={{ m: 3 }} />
                                </>
                            )}
                        </Grid>
                        <Box sx={{ m: '20px' }} />
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                            <Grid item xs={6}>
                                <Controls.Select
                                    name="legalFormId"
                                    label="Forma prawna"
                                    value={legalFormId}
                                    readOnly={isViewOnly}
                                    disabled={!disabledButton}
                                    onChange={localOnChange}
                                    options={legalForms}
                                    variant="outlined"
                                    margin="dense"
                                    error={errors.legalFormId}
                                />
                                <Controls.Select
                                    name="vatStatus"
                                    label="Status VAT"
                                    value={vatStatus}
                                    disabled={!disabledButton}
                                    vatStatus={vatStatus}
                                    onChange={localOnChange}
                                    options={MyCollections.getVatStatus()}
                                    variant="outlined"
                                    margin="dense"
                                    error={errors.vatStatus}
                                />
                                <Controls.Select
                                    name="isGenerateInvoice"
                                    label="Czy generujemy faktury?"
                                    value={isGenerateInvoice}
                                    disabled={!disabledButton}
                                    readOnly={isViewOnly}
                                    isColor={true}
                                    onChange={localOnChange}
                                    options={getTrueFalse()}
                                    variant="outlined"
                                    margin="dense"
                                    error={errors.isGenerateInvoice}
                                />
                                <Controls.Select
                                    name="isCompanyEstablishedBy7PM"
                                    label="7PM zakładało spółkę?"
                                    value={isCompanyEstablishedBy7PM}
                                    isColor={true}
                                    disabled={!disabledButton}
                                    readOnly={isViewOnly}
                                    onChange={localOnChange}
                                    options={getTrueFalse()}
                                    variant="outlined"
                                    margin="dense"
                                    error={errors.isCompanyEstablishedBy7PM}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Controls.Select
                                    name="isContract"
                                    label="Umowa?"
                                    value={isContract}
                                    isColor={true}
                                    disabled={!disabledButton}
                                    readOnly={isViewOnly}
                                    onChange={localOnChange}
                                    options={getTrueFalse()}
                                    variant="outlined"
                                    margin="dense"
                                    error={errors.isContract}
                                />
                                <Controls.Select
                                    name="isContinuationOfJDG"
                                    label="Kontynuacja JDG?"
                                    value={isContinuationOfJDG}
                                    isColor={true}
                                    disabled={!disabledButton}
                                    readOnly={isViewOnly}
                                    onChange={localOnChange}
                                    options={getTrueFalse()}
                                    variant="outlined"
                                    margin="dense"
                                    error={errors.isContinuationOfJDG}
                                />
                                <Controls.Select
                                    name="isTransferOfAccounting"
                                    label="Przeniesienie księgowości?"
                                    value={isTransferOfAccounting}
                                    isColor={true}
                                    disabled={!disabledButton}
                                    readOnly={isViewOnly}
                                    onChange={localOnChange}
                                    options={getTrueFalse()}
                                    variant="outlined"
                                    margin="dense"
                                    error={errors.isTransferOfAccounting}
                                />
                            </Grid>
                        </Grid>
                        <Box sx={{ m: '56px' }} />

                        <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                            <Grid item xs={6}>
                                <Controls.MyDatePicker
                                    name="dateOfEntryInKRS"
                                    label="Data wpisu do KRS/CEIDG"
                                    value={dateOfEntryInKRS}
                                    disabled={!disabledButton}
                                    readOnly={isViewOnly}
                                    onChange={newValue => handleDateChange('dateOfEntryInKRS', newValue)}
                                    error={!!errors.dateOfEntryInKRS}
                                    helperText={errors.dateOfEntryInKRS}
                                    format={"YYYY-MM"}
                                    views={["year", "month"]}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                {legalFormId !== 1 && (
                                    <Controls.MyDatePicker
                                        name="firstFiscalYear"
                                        label="pierwszy rok obrachunkowy"
                                        value={firstFiscalYear}
                                        disabled={!disabledButton}
                                        readOnly={isViewOnly}
                                        onChange={newValue => handleDateChange('firstFiscalYear', newValue)}
                                        error={!!errors.firstFiscalYear}
                                        helperText={errors.firstFiscalYear}
                                        views="year"
                                        format="YYYY"
                                    />
                                )}
                            </Grid>
                        </Grid>
                        <Box sx={{ m: '36px' }} />
                        <Divider />
                        <Box sx={{ m: '10px' }} />
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                            <Grid item xs={12}>
                                <Div>{"Informacje dodatkowe"}</Div>
                            </Grid>
                            <Grid item xs={12}>
                                <DeferredTextField
                                    name="tradersComments"
                                    value={tradersComments}
                                    multiline
                                    onChange={localOnChange}
                                    placeholder="Wprowadź tekst"
                                    label="Uprzejme prośby i sugestie od Zespołu Handlowego do Zespołu Superwizorek :)"
                                    margin="dense"
                                    rows={6}
                                    inputProps={{
                                        maxLength: 1990,
                                        readOnly: isViewOnly
                                    }}
                                    disabled={!disabledButton}
                                    fullWidth
                                    error={!!errors.tradersComments}
                                    helperText={errors.tradersComments}
                                    color="secondary"
                                    focused
                                />
                                <Box sx={{ m: '36px' }} />
                                <DeferredTextField
                                    name="businessDesc"
                                    value={businessDesc}
                                    onChange={localOnChange}
                                    multiline
                                    rows={2}
                                    placeholder="Wprowadź tekst"
                                    label="Firma zajmuje się:"
                                    margin="dense"
                                    maxRows={6}
                                    fullWidth
                                    disabled={!disabledButton}
                                    color="success"
                                    inputProps={{
                                        maxLength: 1990,
                                        readOnly: isViewOnly
                                    }}
                                    focused
                                    error={!!errors.businessDesc}
                                    helperText={errors.businessDesc}
                                />
                            </Grid>
                        </Grid>
                        <Box sx={{ m: '36px' }} />
                        <Divider />
                        <Box sx={{ m: '10px' }} />
                        {id !== null && (
                            <>
                                <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                                    <Grid item xs={12}>
                                        <Div>{"Warunki współpracy"}</Div>
                                    </Grid>
                                    <Box sx={{ m: '10px' }} />
                                </Grid>
                                {tariffList && tariffList.length > 0 && (
                                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
                                        <Grid item xs={6} >
                                            {tariffList.slice(0, 4).map((element, index) => (
                                                <Controls.Select
                                                    key={index}
                                                    name={`clientTariffDTOs[${index}].tclientTariffId`}
                                                    value={element.tclientTariffId}
                                                    options={index === 0 ? tariffs.filter(t => !t.discontinueDate || t.key === element.tclientTariffId) : tariffs}
                                                    style={{ color: '#9c27b0' }}
                                                    disabled={!disabledButton || index !== 0}
                                                    readOnly={isViewOnly}
                                                    label={index === 0 ? "Ostatni zdefiniowany cennik" : "Poprzedni cennik"}
                                                    error={!!(errors.clientTariffDTOs && errors.clientTariffDTOs[index] && errors.clientTariffDTOs[index].tclientTariffId)}
                                                    onChange={localOnChange}
                                                    fullWidth
                                                />
                                            ))}
                                        </Grid>
                                        <Grid item xs={3} >
                                            {tariffList.slice(0, 4).map((element, index) => (
                                                <Controls.MyDatePicker
                                                    key={index}
                                                    name={`clientTariffDTOs[${index}].startDate`}
                                                    label="Obowiązuje od"
                                                    value={element.startDate}
                                                    disabled={!disabledButton || index !== 0}
                                                    readOnly={isViewOnly}
                                                    onChange={newValue => handleDateChange(`clientTariffDTOs[${index}].startDate`, newValue)}
                                                    error={!!(errors.clientTariffDTOs && errors.clientTariffDTOs[index] && errors.clientTariffDTOs[index].startDate)}
                                                    helperText={errors.clientTariffDTOs && errors.clientTariffDTOs[index] ? errors.clientTariffDTOs[index].startDate : undefined}
                                                    format={"YYYY-MM"}
                                                    views={["year", "month"]}
                                                />
                                            ))}
                                        </Grid>
                                        <Grid item xs={3} >
                                            {tariffList.slice(0, 4).map((element, index) => (
                                                <Controls.MyDatePicker
                                                    key={index}
                                                    name={`clientTariffDTOs[${index}].endDate`}
                                                    label="Obowiązuje do"
                                                    value={element.endDate}
                                                    disabled={!disabledButton || index !== 0}
                                                    readOnly={isViewOnly}
                                                    onChange={newValue => handleDateChange(`clientTariffDTOs[${index}].endDate`, newValue)}
                                                    error={!!(errors.clientTariffDTOs && errors.clientTariffDTOs[index] && errors.clientTariffDTOs[index].endDate)}
                                                    helperText={errors.clientTariffDTOs && errors.clientTariffDTOs[index] ? errors.clientTariffDTOs[index].endDate : undefined}
                                                    format={"YYYY-MM"}
                                                    views={["year", "month"]}
                                                />
                                            ))}
                                        </Grid>
                                    </Grid>
                                )}
                                <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                    <Grid item xs={12}>
                                        <ConditionButton variant="contained" disabled={!disabledButton || isViewOnly} style={{ float: 'right' }} color="secondary" onClick={handleAddNewTariff}>
                                            Dodaj nowy cennik
                                        </ConditionButton>
                                        {tariffList?.length > 1 && (
                                            <ConditionButton variant="contained" disabled={!disabledButton || isViewOnly} onClick={handleRemoveLastTariffListElement}>
                                                Usuń ostatni cennik
                                            </ConditionButton>
                                        )}
                                    </Grid>
                                </Grid>
                                <Box sx={{ m: '36px' }} />
                                <Divider />
                                <Box sx={{ m: '10px' }} />
                            </>
                        )}
                        {id !== null && (
                            <>
                                {packageList && packageList.length > 0 && (
                                    <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                                        <Grid item xs={6}>
                                            {packageList.slice(0, 4).map((element, index) => (
                                                <Controls.Select
                                                    key={index}
                                                    name={`clientPackageDTOs[${index}].tpackageTypeId`}
                                                    label={index === 0 ? "Ostatni zdefiniowany pakiet" : "Poprzedni pakiet"}
                                                    value={element.tpackageTypeId}
                                                    onChange={localOnChange}
                                                    options={index === 0 ? packagesLocal : packages}
                                                    disabled={!disabledButton || index !== 0}
                                                    readOnly={isViewOnly}
                                                    variant="outlined"
                                                    margin="dense"
                                                    error={!!(errors.clientPackageDTOs && errors.clientPackageDTOs[index] && errors.clientPackageDTOs[index].tpackageTypeId)}
                                                />
                                            ))}
                                        </Grid>
                                        <Grid item xs={3}>
                                            {packageList.slice(0, 4).map((element, index) => (
                                                <Controls.MyDatePicker
                                                    key={index}
                                                    name={`clientPackageDTOs[${index}].startDate`}
                                                    label="Od"
                                                    value={element.startDate}
                                                    disabled={!disabledButton || index !== 0}
                                                    readOnly={isViewOnly}
                                                    onChange={newValue => handleDateChange(`clientPackageDTOs[${index}].startDate`, newValue)}
                                                    error={!!(errors.clientPackageDTOs && errors.clientPackageDTOs[index] && errors.clientPackageDTOs[index].startDate)}
                                                    helperText={errors.clientPackageDTOs && errors.clientPackageDTOs[index] ? errors.clientPackageDTOs[index].startDate : undefined}
                                                    format={"YYYY-MM"}
                                                    views={["year", "month"]}
                                                />
                                            ))}
                                        </Grid>
                                        <Grid item xs={3}>
                                            {packageList.slice(0, 4).map((element, index) => (
                                                <Controls.MyDatePicker
                                                    key={index}
                                                    name={`clientPackageDTOs[${index}].endDate`}
                                                    label="Do"
                                                    value={element.endDate}
                                                    disabled={!disabledButton || index !== 0}
                                                    readOnly={isViewOnly}
                                                    onChange={newValue => handleDateChange(`clientPackageDTOs[${index}].endDate`, newValue)}
                                                    error={!!(errors.clientPackageDTOs && errors.clientPackageDTOs[index] && errors.clientPackageDTOs[index].endDate)}
                                                    helperText={errors.clientPackageDTOs && errors.clientPackageDTOs[index] ? errors.clientPackageDTOs[index].endDate : undefined}
                                                    format={"YYYY-MM"}
                                                    views={["year", "month"]}
                                                />
                                            ))}
                                        </Grid>
                                    </Grid>
                                )}
                                <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                    <Grid item xs={12}>
                                        <ConditionButton variant="contained" disabled={!disabledButton || isViewOnly} style={{ float: 'right' }} color="secondary" onClick={handleAddNewPackage}>
                                            Dodaj nowy pakiet
                                        </ConditionButton>
                                        {packageList?.length > 1 && (
                                            <>
                                                <ConditionButton variant="contained" disabled={!disabledButton || isViewOnly} onClick={handleRemoveLastPackageListElement}>
                                                    Usuń ostatni pakiet
                                                </ConditionButton>
                                                <Box sx={{ m: '45px' }} />
                                            </>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                    <Grid item xs={12}>
                                        <Controls.Checkbox
                                            name="isPaidInAdvance"
                                            label="Opłacono z góry?"
                                            value={isPaidInAdvance}
                                            disabled={!disabledButton || isViewOnly}
                                            onChange={localOnChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid item xs={3}>
                                            {isPaidInAdvance ? (
                                                <>
                                                    <Controls.MyDatePicker
                                                        name="paidInAdvanceTo"
                                                        label="Opłacono z góry do"
                                                        value={paidInAdvanceTo}
                                                        disabled={!disabledButton}
                                                        readOnly={isViewOnly}
                                                        onChange={newValue => handleDateChange('paidInAdvanceTo', newValue)}
                                                        error={!!errors.paidInAdvanceTo}
                                                        helperText={errors.paidInAdvanceTo}
                                                        format="YYYY-MM"
                                                        views={["year", "month"]}
                                                    />
                                                    <Box sx={{ m: '15px' }} />
                                                </>
                                            ) : null}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Box sx={{ m: '36px' }} />
                                <Divider />
                                <Box sx={{ m: '10px' }} />
                            </>
                        )}
                        {id === null && (
                            <>
                                <Grid item xs={12}>
                                    <Div>{"Warunki współpracy"}</Div>
                                </Grid>
                                <Box sx={{ m: '10px' }} />
                                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
                                    <Grid item xs={6} >
                                        <Controls.Select
                                            name={`clientTariffDTOs[0].tclientTariffId`}
                                            value={clientTariffDTOs?.[0]?.tclientTariffId}
                                            options={tariffs}
                                            readOnly={isViewOnly}
                                            style={{ color: '#9c27b0' }}
                                            label="Cennik"
                                            error={!!(errors.clientTariffDTOs && errors.clientTariffDTOs[0] && errors.clientTariffDTOs[0].tclientTariffId)}
                                            onChange={localOnChange}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={6} >
                                        <Controls.MyDatePicker
                                            name={`clientTariffDTOs[0].startDate`}
                                            label="Od"
                                            value={clientTariffDTOs?.[0]?.startDate}
                                            readOnly={isViewOnly}
                                            minDate={minDate}
                                            disabled={clientTariffDTOs?.[0]?.tclientTariffId === ''}
                                            onChange={newValue => handleDateChange(`clientTariffDTOs[0].startDate`, newValue)}
                                            error={!!(errors.clientTariffDTOs && errors.clientTariffDTOs[0] && errors.clientTariffDTOs[0].startDate)}
                                            helperText={errors.clientTariffDTOs && errors.clientTariffDTOs[0] ? errors.clientTariffDTOs[0].startDate : undefined}
                                            format={"YYYY-MM"}
                                            views={["year", "month"]}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                                    <Grid item xs={6}>
                                        <Controls.Select
                                            name={`clientPackageDTOs[0].tpackageTypeId`}
                                            label="Pakiet"
                                            value={clientPackageDTOs?.[0]?.tpackageTypeId}
                                            disabled={clientTariffDTOs?.[0]?.tclientTariffId === ''}
                                            onChange={localOnChange}
                                            readOnly={isViewOnly}
                                            options={packagesLocal}
                                            variant="outlined"
                                            margin="dense"
                                            error={!!(errors.clientPackageDTOs && errors.clientPackageDTOs[0] && errors.clientPackageDTOs[0].tpackageTypeId)}
                                        /></Grid>
                                    <Grid item xs={6}>
                                        <Controls.MyDatePicker
                                            name={`clientPackageDTOs[0].startDate`}
                                            label="Od"
                                            value={clientPackageDTOs?.[0]?.startDate}
                                            readOnly={isViewOnly}
                                            disabled={clientTariffDTOs?.[0]?.tclientTariffId === ''}
                                            onChange={newValue => handleDateChange(`clientPackageDTOs[0].startDate`, newValue)}
                                            error={!!(errors.clientPackageDTOs && errors.clientPackageDTOs[0] && errors.clientPackageDTOs[0].startDate)}
                                            helperText={errors.clientPackageDTOs && errors.clientPackageDTOs[0] ? errors.clientPackageDTOs[0].startDate : undefined}
                                            format={"YYYY-MM"}
                                            views={["year", "month"]}
                                        />
                                    </Grid>
                                </Grid>
                                <Box sx={{ m: '20px' }} />
                                <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                    <Grid item xs={12}>
                                        <Controls.Checkbox
                                            name="isPaidInAdvance"
                                            label="Opłacono z góry?"
                                            value={isPaidInAdvance}
                                            disabled={!disabledButton || isViewOnly}
                                            onChange={localOnChange}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid item xs={3}>
                                            {isPaidInAdvance ? (
                                                <>
                                                    <Controls.MyDatePicker
                                                        name="paidInAdvanceTo"
                                                        label="Opłacono z góry do"
                                                        value={paidInAdvanceTo}
                                                        disabled={!disabledButton}
                                                        readOnly={isViewOnly}
                                                        onChange={newValue => handleDateChange('paidInAdvanceTo', newValue)}
                                                        error={!!errors.paidInAdvanceTo}
                                                        helperText={errors.paidInAdvanceTo}
                                                        format="YYYY-MM"
                                                        views={["year", "month"]}
                                                    />
                                                </>
                                            ) : null}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Box sx={{ m: '35px' }} />
                                <Divider />
                                <Box sx={{ m: '10px' }} />
                            </>
                        )}
                        <Grid container rowSpacing={{ xs: 1, sm: 1, md: 2 }} spacing={{ xs: 1, sm: 2, md: 2 }} columns={{ xs: 2, sm: 6, md: 12 }}>
                            <Grid item xs={12}>
                                <Div>{"Historia współpracy"}</Div>
                            </Grid>
                            <Grid item xs={4}>
                                <Controls.Select
                                    name="obtainedByContactId"
                                    label="Kto pozyskał klienta"
                                    value={obtainedByContactId}
                                    readOnly={isViewOnly}
                                    disabled={!disabledButton}
                                    onChange={localOnChange}
                                    options={users}
                                    variant="outlined"
                                    margin="dense"
                                    error={errors.users}
                                />
                            </Grid>
                            {id === null ? (
                                <>
                                    <Grid item xs={8}></Grid>
                                    <Grid item xs={4}>
                                        <Controls.MyDatePicker
                                            name="cooperationHistoryDTOs[0].cooperationStartDate"
                                            label="Start współpracy (od kiedy księgujemy i fakturujemy)"
                                            value={cooperationHistoryDTOs?.[0]?.cooperationStartDate}
                                            disabled={!disabledButton || cooperationHistoryDTOs[0]?.cooperationEndDate}
                                            readOnly={isViewOnly}
                                            onChange={newValue => handleDateChange('cooperationHistoryDTOs[0].cooperationStartDate', newValue)}
                                            error={!!(errors.cooperationHistoryDTOs && errors.cooperationHistoryDTOs[0] && errors.cooperationHistoryDTOs[0].cooperationStartDate)}
                                            helperText={errors.cooperationHistoryDTOs && errors.cooperationHistoryDTOs[0] ? errors.cooperationHistoryDTOs[0].cooperationStartDate : undefined}
                                            format="YYYY-MM"
                                            views={["year", "month"]}
                                        />
                                    </Grid>
                                    <Grid item xs={8}></Grid>
                                </>
                            ) : (
                                <Grid item xs={6}></Grid>
                            )}
                            {id !== null && (
                                <>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            direction="row"  // Ustawiamy kontener w układzie poziomym
                                            rowSpacing={{ xs: 1, sm: 1, md: 2 }}
                                            spacing={{ xs: 1, sm: 2, md: 2 }}
                                            columns={{ xs: 2, sm: 6, md: 12 }}
                                            alignItems="center"  // Opcjonalnie wyśrodkowanie elementów w pionie
                                        >
                                            <Grid item xs={12}>
                                                <Grid container spacing={{ xs: 1, sm: 2, md: 2 }}>
                                                    {(!isResumingFromSuspension && (!suspended && ((active && !cooperationEndedInFuture && !cooperationEnded) || (isResume && cooperationEnded)) || cooperationEndedClicked || cooperationSuspendedClicked || cooperationStartsInFuture)) && (
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Controls.MyDatePicker
                                                                name={hasResumedFromEnded ? `cooperationHistoryDTOs[${cooperationHistoryDTOs.length - 1}].cooperationStartDate` : "cooperationHistoryDTOs[0].cooperationStartDate"}
                                                                label={"Start współpracy (od kiedy księgujemy i fakturujemy)"}
                                                                value={cooperationHistoryDTOs?.[hasResumedFromEnded ? cooperationHistoryDTOs.length - 1 : 0]?.cooperationStartDate}
                                                                disabled={!disabledButton || (hasResumedFromEnded ? cooperationHistoryDTOs[cooperationHistoryDTOs.length - 1]?.cooperationEndDate : cooperationHistoryDTOs[0]?.cooperationEndDate)}
                                                                readOnly={isViewOnly}
                                                                onChange={newValue => handleDateChange(`cooperationHistoryDTOs[${hasResumedFromEnded ? cooperationHistoryDTOs.length - 1 : 0}].cooperationStartDate`, newValue)}
                                                                error={!!(errors.cooperationHistoryDTOs && errors.cooperationHistoryDTOs[hasResumedFromEnded ? cooperationHistoryDTOs.length - 1 : 0] && errors.cooperationHistoryDTOs[hasResumedFromEnded ? cooperationHistoryDTOs.length - 1 : 0].cooperationStartDate)}
                                                                helperText={errors.cooperationHistoryDTOs && errors.cooperationHistoryDTOs[hasResumedFromEnded ? cooperationHistoryDTOs.length - 1 : 0] ? errors.cooperationHistoryDTOs[hasResumedFromEnded ? cooperationHistoryDTOs.length - 1 : 0].cooperationStartDate : undefined}
                                                                format="YYYY-MM"
                                                                views={["year", "month"]}
                                                            />
                                                        </Grid>
                                                    )}
                                                    {hasResumedFromEnded && (
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Controls.MyDatePicker
                                                                name="cooperationHistoryDTOs[0].cooperationStartDate"
                                                                label={"Wznowienie współpracy od: "}
                                                                value={cooperationHistoryDTOs?.[0]?.cooperationStartDate}
                                                                disabled={!disabledButton || cooperationHistoryDTOs[0]?.cooperationEndDate}
                                                                readOnly={isViewOnly}
                                                                onChange={newValue => handleDateChange('cooperationHistoryDTOs[0].cooperationStartDate', newValue)}
                                                                error={!!(errors.cooperationHistoryDTOs && errors.cooperationHistoryDTOs[0] && errors.cooperationHistoryDTOs[0].cooperationStartDate)}
                                                                helperText={errors.cooperationHistoryDTOs && errors.cooperationHistoryDTOs[0] ? errors.cooperationHistoryDTOs[0].cooperationStartDate : undefined}
                                                                format="YYYY-MM"
                                                                views={["year", "month"]}
                                                            />
                                                        </Grid>
                                                    )}
                                                    {((suspended || isResumingFromSuspension) && isResume) && (
                                                        <Grid item xs={12} sm={6} md={4}>
                                                            <Controls.MyDatePicker
                                                                name="cooperationHistoryDTOs[1].suspensionEndDate"
                                                                label={"Koniec zawieszenia od: "}
                                                                value={cooperationHistoryDTOs?.[1]?.suspensionEndDate}
                                                                disabled={!disabledButton}
                                                                readOnly={isViewOnly}
                                                                onChange={newValue => handleDateChange('cooperationHistoryDTOs[1].suspensionEndDate', newValue)}
                                                                error={!!(errors.cooperationHistoryDTOs && errors.cooperationHistoryDTOs[1] && errors.cooperationHistoryDTOs[1].suspensionEndDate)}
                                                                helperText={errors.cooperationHistoryDTOs && errors.cooperationHistoryDTOs[1] ? errors.cooperationHistoryDTOs[1].suspensionEndDate : undefined}
                                                                format="YYYY-MM"
                                                                views={["year", "month"]}
                                                            />
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 1 }}>
                                                    {active && !cooperationEndedInFuture && !isResume && !cooperationEnded && !suspensionStartDateInFuture ? (
                                                        <>
                                                            <Button
                                                                color="secondary"
                                                                disabled={isViewOnly}
                                                                size="medium"
                                                                onClick={handleOpenEndDialog}
                                                                variant="contained"
                                                                sx={{ minWidth: 180, whiteSpace: 'nowrap' }}
                                                            >
                                                                Zakończ współpracę
                                                            </Button>
                                                            <Button
                                                                color="primary"
                                                                size="medium"
                                                                disabled={isViewOnly}
                                                                onClick={handleOpenSuspendDialog}
                                                                variant="contained"
                                                                sx={{ minWidth: 180, whiteSpace: 'nowrap' }}
                                                            >
                                                                Zawieś współpracę
                                                            </Button>
                                                        </>
                                                    ) : (
                                                        (cooperationStatus === "FUTURE_END" || cooperationStatus === "FUTURE_SUSPENSION") ? null : (
                                                            !isResume && !cooperationStartsInFuture && !suspensionEndDateInFuture && !suspensionStartDateInFuture && !cooperationEndedInFuture ? (
                                                                <Button
                                                                    variant="contained"
                                                                    color="secondary"
                                                                    onClick={handleOpenResumeDialog}
                                                                    sx={{ minWidth: 180, whiteSpace: 'nowrap' }}
                                                                >
                                                                    Wznów współpracę
                                                                </Button>
                                                            ) : null
                                                        )
                                                    )}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Box sx={{ m: '26px' }} />
                                        {cooperationHistoryList && cooperationHistoryList.length > 0 ? (
                                            <Grid container rowSpacing={0.5} spacing={{ xs: 1, sm: 2, md: 4 }}>
                                                <Grid item xs={12}>
                                                    {cooperationHistoryList?.filter(element => !element.suspended && element.cooperationEndDate != null).length > 0 && (
                                                        <Grid>
                                                            <Div>{"Okresy współpracy"}</Div>
                                                        </Grid>
                                                    )}
                                                    <Grid container rowSpacing={0.5} spacing={{ xs: 1, sm: 1, md: 2 }}>
                                                        {cooperationHistoryList.slice(0, 10).map((element, index) => (
                                                            <Grid item xs={12} key={index}>
                                                                {!element.suspended && element.cooperationEndDate != null ? (
                                                                    <>
                                                                        <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="center">
                                                                            <Grid item xs={12} sm>
                                                                                <Controls.MyDatePicker
                                                                                    name={`cooperationStartDate`}
                                                                                    label="Data rozpoczęcia współpracy"
                                                                                    value={element.cooperationStartDate}
                                                                                    disabled={true}
                                                                                    format={"YYYY-MM"}
                                                                                    views={["year", "month"]}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} sm>
                                                                                <Controls.MyDatePicker
                                                                                    name={`cooperationEndDate`}
                                                                                    label="Data zakończenia współpracy"
                                                                                    value={element.cooperationEndDate}
                                                                                    disabled={true}
                                                                                    format={"YYYY-MM"}
                                                                                    views={["year", "month"]}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={12} sm>
                                                                                <Controls.Select
                                                                                    name={`reasonForTerminatingCooperationId`}
                                                                                    label="Powód zakończenia współpracy"
                                                                                    value={element.reasonForTerminatingCooperationId}
                                                                                    options={reasons}
                                                                                    disabled={true}
                                                                                    style={{ color: '#9c27b0' }}
                                                                                    onChange={localOnChange}
                                                                                    fullWidth
                                                                                />
                                                                            </Grid>
                                                                            {(index === 0 && (cooperationStatus === "FUTURE_END" || cooperationStatus === "ENDED")) && (
                                                                                <Grid item xs={12} sm="auto">
                                                                                    <Button
                                                                                        variant="contained"
                                                                                        color="primary"
                                                                                        onClick={handleCancelCooperation}
                                                                                    >
                                                                                        Anuluj
                                                                                    </Button>
                                                                                </Grid>
                                                                            )}
                                                                        </Grid>
                                                                    </>
                                                                ) : null}
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                    {cooperationHistoryList?.filter(element => element.suspended === true || element.suspensionStartDate != null).length > 0 && (
                                                        <Grid><Div>{"Okresy zawieszonej współpracy"}</Div></Grid>
                                                    )}
                                                    <Grid container rowSpacing={0.5} spacing={{ xs: 1, sm: 1, md: 2 }}>
                                                        {cooperationHistoryList.slice(0, 10).map((element, index) => (
                                                            <Grid item xs={12} key={index}>
                                                                {element.suspended || element.suspensionStartDate != null ? (
                                                                    <Grid container rowSpacing={0.5} spacing={{ xs: 1, sm: 1, md: 2 }} alignItems="center">
                                                                        <Grid item xs={12} sm>
                                                                            <Controls.MyDatePicker
                                                                                name="suspensionStartDate"
                                                                                label="Data zawieszenia współpracy"
                                                                                value={element.suspensionStartDate}
                                                                                disabled={true}
                                                                                format="YYYY-MM"
                                                                                views={["year", "month"]}
                                                                            />
                                                                        </Grid>
                                                                        {element.suspensionEndDate != null && (
                                                                            <Grid item xs={12} sm>
                                                                                <Controls.MyDatePicker
                                                                                    name="suspensionEndDate"
                                                                                    label="Data końca zawieszenia"
                                                                                    value={element.suspensionEndDate}
                                                                                    disabled={true}
                                                                                    format="YYYY-MM"
                                                                                    views={["year", "month"]}
                                                                                />
                                                                            </Grid>
                                                                        )}
                                                                        <Grid item xs={12} sm>
                                                                            <Controls.Select
                                                                                name="reasonForTerminatingCooperationId"
                                                                                label="Powód zawieszenia współpracy"
                                                                                value={element.reasonForTerminatingCooperationId}
                                                                                options={reasons}
                                                                                disabled={true}
                                                                                style={{ color: '#9c27b0' }}
                                                                                fullWidth
                                                                            />
                                                                        </Grid>
                                                                        {(index === 0 && (cooperationStatus === "FUTURE_SUSPENSION" || cooperationStatus === "SUSPENDED")) && (
                                                                            <Grid item xs={12} sm="auto">
                                                                                <Button
                                                                                    variant="contained"
                                                                                    color="primary"
                                                                                    onClick={handleCancelCooperation}
                                                                                >
                                                                                    Anuluj
                                                                                </Button>
                                                                            </Grid>
                                                                        )}
                                                                    </Grid>
                                                                ) : null}
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        ) : null}
                                    </Grid>
                                </>
                            )}
                        </Grid>
                        <Box sx={{ m: '5px' }} />
                        <Divider />
                        <Box sx={{ m: '10px' }} />
                        <Grid container rowSpacing={1} spacing={{ xs: 2, md: 4 }} columns={{ xs: 2, sm: 6, md: 12 }}>
                            <Grid item xs={12}>
                                <Div>{"Historia obsługi"}</Div>
                                <Box sx={{ m: '15px' }} />
                                {accountantDTOs && accountantDTOs.length > 0 ? (
                                    <Grid container rowSpacing={1} spacing={{ xs: 1, sm: 2, md: 4 }}>
                                        <Grid item xs={6}>
                                            {accountantDTOs.slice(0, 4).map((element, index) => (
                                                <Controls.Select
                                                    name={`accountantDTOs[${index}].contactIdA`}
                                                    options={index === 0 ? activeAccountants : accountants}
                                                    value={element.contactIdA}
                                                    style={{ color: '#9c27b0' }}
                                                    readOnly={isViewOnly}
                                                    label={index === 0 ? 'Aktualna księgowa/y' : 'Poprzednia księgowa/y'}
                                                    onChange={localOnChange}
                                                    fullWidth
                                                    disabled={!disabledButton || index !== 0}
                                                    error={errors.accountantDTOs && errors.accountantDTOs[index] ? errors.accountantDTOs[index].contactIdA : ''} />
                                            ))}
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Grid container rowSpacing={1} spacing={{ xs: 1, sm: 1, md: 2 }}>
                                                <Grid item xs={6}>
                                                    {accountantDTOs.slice(0, 4).map((element, index) => (
                                                        <Controls.MyDatePicker
                                                            key={index}
                                                            name={`accountantDTOs[${index}].startDate`}
                                                            label="Od"
                                                            disabled={!disabledButton || index !== 0 || !changeAllowed}
                                                            readOnly={isViewOnly}
                                                            value={element.startDate}
                                                            error={!!(errors.accountantDTOs && errors.accountantDTOs[index] && errors.accountantDTOs[index].startDate)}
                                                            helperText={errors.accountantDTOs && errors.accountantDTOs[index] ? errors.accountantDTOs[index].startDate : undefined}
                                                            onChange={newValue => handleDateChange(`accountantDTOs[${index}].startDate`, newValue)}
                                                            style={{ width: '50px' }}
                                                            format={"YYYY-MM"}
                                                            views={["year", "month"]}
                                                        />
                                                    ))}
                                                </Grid>
                                                <Grid item xs={6}>
                                                    {accountantDTOs.slice(0, 4).map((element, index) => (
                                                        <Controls.MyDatePicker
                                                            key={index}
                                                            name={`accountantDTOs[${index}].endDate`}
                                                            label="Do"
                                                            disabled={!disabledButton || index !== 0 || !changeAllowed}
                                                            readOnly={isViewOnly}
                                                            value={element.endDate}
                                                            error={!!(errors.accountantDTOs && errors.accountantDTOs[index] && errors.accountantDTOs[index].endDate)}
                                                            helperText={errors.accountantDTOs && errors.accountantDTOs[index] ? errors.accountantDTOs[index].endDate : undefined}
                                                            onChange={newValue => handleDateChange(`accountantDTOs[${index}].endDate`, newValue)}
                                                            format={"YYYY-MM"}
                                                            views={["year", "month"]}
                                                        />
                                                    ))}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <div></div>
                                )}
                            </Grid>
                        </Grid>
                        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={12}>
                                <ConditionButton variant="contained" disabled={!disabledButton || isViewOnly || (!changeAllowed && accountantDTOs && accountantDTOs.length !== 0)} style={{ float: 'right' }} color="secondary" onClick={handleAddNewAccountant}>
                                    {accountantDTOs && accountantDTOs.length > 0 ? "Dodaj kolejny element" : "Przypisz księgową"}
                                </ConditionButton>
                                {accountantDTOs && accountantDTOs.length >= 1 && (isRemoveButtonVisible || accountantDTOs[0].id === null) && (
                                    <ConditionButton variant="contained" disabled={!disabledButton || isViewOnly} onClick={handleRemoveLastAccountantElement}>
                                        Usuń ostatni element
                                    </ConditionButton>
                                )}
                            </Grid>
                        </Grid>
                        <Box sx={{ m: '35px' }} />

                        {/* Rabaty i rekompensaty*/}
                        <Divider />
                        <Box sx={{ m: '15px' }} />
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                            <Grid item xs={12}>
                                <Div>Rabaty, rekompensaty / Dopłaty</Div>
                            </Grid>
                            <Box sx={{ m: '5px' }} />
                            <Grid item xs={12}>
                                <DiscountComponent
                                    contactId={contactId}
                                    userName={userName}
                                    discounts={formData.discountDTOs || []}
                                    setDiscounts={(newList) =>
                                        setFormData(prev => ({ ...prev, discountDTOs: newList }))
                                    }
                                    roles={roles}
                                />
                            </Grid>
                        </Grid>
                        {(id !== null && roles?.includes('ADMIN') || roles?.includes('ADMIN_SUPERVISOR')) && (
                            <>
                                <Box sx={{ m: '36px' }} />
                                <Divider />
                                <Box sx={{ m: '20px' }} />
                                <Grid container spacing={2}>

                                    {/* ===== Nagłówek ===== */}
                                    <Grid item xs={12}>
                                        <Div>Konta bankowe</Div>
                                    </Grid>

                                    {/* ===== Sekcja eksportu ===== */}
                                    <Grid item xs={12}>
                                        <Grid container spacing={2} alignItems="center">
                                            {formData.isConsentActive ? (
                                                <>
                                                    <Grid item>
                                                        <FormControl size="small" sx={{ minWidth: 160 }}>
                                                            <InputLabel id="format-select-label">Format</InputLabel>
                                                            <Select
                                                                labelId="format-select-label"
                                                                value={selectedFormat}
                                                                label="Format"
                                                                onChange={(e) => setSelectedFormat(e.target.value)}
                                                            >
                                                                <MenuItem value="csv">CSV</MenuItem>
                                                                <MenuItem value="excel">Excel</MenuItem>
                                                                <MenuItem value="mt940">MT940</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>

                                                    <Grid item>
                                                        <Button
                                                            variant="contained"
                                                            onClick={() => downloadTransactions(id, selectedFormat)}
                                                            sx={{ whiteSpace: "nowrap" }}
                                                        >
                                                            Pobierz wyciągi
                                                        </Button>
                                                    </Grid>

                                                    <Grid item>
                                                        <Button
                                                            variant="outlined"
                                                            color="secondary"
                                                            onClick={getAccounts}
                                                            sx={{ whiteSpace: "nowrap" }}
                                                        >
                                                            Wyświetl dane kont
                                                        </Button>
                                                    </Grid>
                                                </>
                                            ) : (
                                                <Grid item xs={12}>
                                                    <Typography variant="caption" textAlign="left" color="text.secondary" marginLeft={2}>
                                                        Brak aktywnej zgody klienta na dostęp do informacji o kontach bankowych.
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid>
                                    {/* ===== Tabela kont ===== */}
                                    {accounts && accounts.length > 0 && (
                                        <Grid item xs={12}>
                                            <TableContainer component={Paper}>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>Nazwa i adres</TableCell>
                                                            <TableCell>Numer konta</TableCell>
                                                            <TableCell>Waluta</TableCell>
                                                            <TableCell align="right">Saldo dostępne</TableCell>
                                                            <TableCell align="right">Saldo księgowe</TableCell>
                                                            <TableCell>Opis rachunku</TableCell>
                                                            <TableCell>Id konta</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {accounts.map((account, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell>
                                                                    {account.details?.nameAddress}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {account.details?.accountNumber}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {account.details?.currency}
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    {Number(account.details?.availableBalance).toLocaleString()}
                                                                </TableCell>
                                                                <TableCell align="right">
                                                                    {Number(account.details?.bookingBalance).toLocaleString()}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {account.details?.accountDescription}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {account.details?.accountId}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    )}
                                </Grid>
                            </>
                        )}
                        {/* Komentarze*/}
                        {isViewOnly ? null : (
                            <>
                                <Box sx={{ m: '36px' }} />
                                <Divider />
                                <Box sx={{ m: '15px' }} />
                                <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                                    <Grid item xs={12}>
                                        <Div>Komentarze</Div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TimelineComponent setFormData={setFormData} formData={formData} />
                                    </Grid>
                                </Grid>
                            </>
                        )}
                        <Box sx={{ m: '40px' }} />
                        <Box sx={{ m: '100px' }} />

                    </form>
                </DialogContent>
                <DialogActions>
                    <Controls.PremiumButton
                        variant="glass"
                        onClick={localHandleClose}
                        label="Anuluj"
                    />
                    <Controls.PremiumButton
                        variant="green"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                        icon={id === null ? "fas fa-plus" : "fas fa-save"}
                        label={id === null ? "Dodaj" : "Aktualizuj"}
                    />
                </DialogActions>
            </Dialog>

            {/* Popup Dialog dla Zakończenia Współpracy */}
            <Dialog open={openEndDialog} onClose={() => setOpenEndDialog(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Zakończenie współpracy</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <Controls.MyDatePicker
                            name="localEndDate"
                            label="Data zakończenia współpracy"
                            value={localEndDate}
                            onChange={newValue => {
                                setLocalEndDate(newValue);
                                setLocalErrors(prev => ({ ...prev, endDate: null }));
                            }}
                            error={!!localErrors.endDate}
                            helperText={localErrors.endDate}
                            format="YYYY-MM"
                            views={["year", "month"]}
                        />
                        <Controls.Select
                            name="localReasonId"
                            value={localReasonId}
                            options={reasons}
                            label="Powód zakończenia współpracy"
                            error={!!localErrors.reasonId}
                            onChange={e => {
                                setLocalReasonId(e.target.value);
                                setLocalErrors(prev => ({ ...prev, reasonId: null }));
                            }}
                            fullWidth
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenEndDialog(false)} color="secondary">
                        Anuluj
                    </Button>
                    <Button onClick={submitEndCooperation} color="primary" variant="contained">
                        Zatwierdź
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Popup Dialog dla Zawieszenia Współpracy */}
            <Dialog open={openSuspendDialog} onClose={() => setOpenSuspendDialog(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Zawieszenie współpracy</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <Controls.MyDatePicker
                            name="localStartDate"
                            label="Data zawieszenia współpracy"
                            value={localStartDate}
                            onChange={newValue => {
                                setLocalStartDate(newValue);
                                setLocalErrors(prev => ({ ...prev, startDate: null }));
                            }}
                            error={!!localErrors.startDate}
                            helperText={localErrors.startDate}
                            format="YYYY-MM"
                            views={["year", "month"]}
                        />
                        <Controls.Select
                            name="localReasonId"
                            value={localReasonId}
                            options={reasons}
                            label="Powód zawieszenia współpracy"
                            error={!!localErrors.reasonId}
                            onChange={e => {
                                setLocalReasonId(e.target.value);
                                setLocalErrors(prev => ({ ...prev, reasonId: null }));
                            }}
                            fullWidth
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenSuspendDialog(false)} color="secondary">
                        Anuluj
                    </Button>
                    <Button onClick={submitSuspendCooperation} color="primary" variant="contained">
                        Zatwierdź
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Popup Dialog dla Wznowienia Współpracy */}
            <Dialog open={openResumeDialog} onClose={() => setOpenResumeDialog(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Wznowienie współpracy</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <Controls.MyDatePicker
                            name="localResumeDate"
                            label={suspended ? "Data końca zawieszenia" : "Data wznowienia współpracy"}
                            value={localResumeDate}
                            onChange={newValue => {
                                setLocalResumeDate(newValue);
                                setLocalErrors(prev => ({ ...prev, resumeDate: null }));
                            }}
                            error={!!localErrors.resumeDate}
                            helperText={localErrors.resumeDate}
                            format="YYYY-MM"
                            views={["year", "month"]}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenResumeDialog(false)} color="secondary">
                        Anuluj
                    </Button>
                    <Button onClick={submitResumeCooperation} color="primary" variant="contained">
                        Zatwierdź
                    </Button>
                </DialogActions>
            </Dialog>
        </div >
    );
}